/* eslint-disable no-prototype-builtins */
/* eslint-disable no-async-promise-executor */
/* eslint-disable no-unused-vars */
/**
 * services will have all the data integration logic.
 * firebase connections and data mapping will be done via various functions defined within services.
 *
 */

import {
  workersRef,
  punchesRef,
  timesheetsRef,
  countriesRef,
  collectionRef,
  collectionGroup,
  CL_JOB_FAMILIES,
  CL_ACTIVITY_GROUPS,
  CL_LOCATIONS,
  CL_COUNTRIES,
  LOCATIONS_DEV,
  storageRef,
  storageRefUpload,
  storageGlobalRefUpload,
  CL_EXCEPTIONS,
  ASC,
  storageImwarehouseRefUpload,
  warehouseprojectRef,
  // collectionGroup,
} from "./firebase";
import firebase from "firebase";
import { categoryPunch } from "../pages/Punch/constants";
import { DEVICE_DETAILS, MISSED_CLOCK_OUT } from "../../src/config/index";
import { CLOCK_OUT } from "../config";
import { v4 as uuidv4 } from "uuid";
import { getPunch } from "../utils/punch";
import { db } from "./firebase";
import {
  AUTH_VALID_EMAIL,
  APPROVED,
  DELETED,
  COUNTRY,
  EMAIL,
  EQUALS,
  FIRST_NAME,
  IN,
  // IS_MANAGER,
  LAST_NAME,
  MANAGER_ID,
  WORKER_ID,
  WORKER_TYPE,
  NEW,
  STATUS,
  ARRAY_LIMIT,
  workerHistory,
  punchHistory,
  BUILDINGS,
  IN_TS,
  CWK_ID_LENGTH,
  CUSTOMER_SITE,
  SPACE,
  WORKER_ROLES,
  WORKER_ROLES_HISTORY,
  IS_DELETED,
  NOT_EQUALS,
  IS_APPROVER,
  STATUS_OUT,
  COUNTRIES,
  IMT_ACTIVITY_GROUP,
  IMT_ACTIVITY_GROUPHISTORY,
  LOCATIONS_COLLECTION,
  BUILDINGS_SUBCOLLECTION,
  COUNTRY_NAME,
  REMOTE,
  LAST,
  COUNTRYCODE,
  workersSchedule,
  workersScheduleHistory,
  GREATER_THAN_OR_EQUAL_TO,
  LESS_THAN_OR_EQUAL_TO,
  WEEK_NUMBER,
  TRIPDELETED,
  IMW_PROJECTS,
  SORTSCAN,
  JOB_TYPE,
  ITContractor
} from "config/CONSTANTS";

import { MEAL } from "../pages/Punch/constants";

import moment from "moment";
import { dateConfig } from "config";
import { ADD, EDIT, IS_ACTIVE_WORKER } from "pages/AddWorker/config";
import { EMPTY, SET_EMPTY } from "pages/Punch/config";
import { isEmptyObject } from "utils";

// CONSTANTS
const storageBasePath = "/ContingentWorkers/";
const storageBasePathIdea = "/GlobalOpsSurvey/";
 
/**
 * function to upload a file to storage bucket.
 * @param {JsFileObj} fileObj
 */
export const uploadCwkCsv = (fileObj) => {
  console.log("services > uploadCwkCsv called...");
  return new Promise((resolve, reject) => {
    try {
      // Filename format should be of type "IMTime_ContingentWorkers_YYYY_MM_DD.csv"
      let fileName = `${storageBasePath}IMTime_ContingentWorkers_${moment()
        .utc()
        .format(dateConfig.format8)}.csv`;
      let fileUploadRef = storageRef.child(fileName);
      fileUploadRef
        .put(fileObj)
        .then(function (snapshot) {
          console.log("File uploaded successfully as=", fileName);
          resolve(true);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (error) {
      console.error("in services > uploadCwkCsv, Err===", error);
      reject(error);
    }
  });
};

/**
 * fn for fetching worker details.
 * @param {string} - employee ID number
 * @return: Promise - return the promise with worker details
 */
export const getWarehouseProject = async (project) => {
  return new Promise((resolve, reject) =>{
    try{
      warehouseprojectRef()
      .doc(SORTSCAN)
      .collection(project)
      .get().then((documentSnapshot)=>{
        const projectData = [];
        documentSnapshot.forEach((doc) => {
          console.log("workerDoc",doc.data())
          projectData.push(doc.data());
        })
       
       resolve(projectData);

      
      });
    }catch(err){
      reject(err);
      console.log("error fetching Worker Activity", err)
    }
})
}

export const saveWarehouseProjectData = (docID,user) => {
  console.log("docID",docID,user.countryCode,user.workerId);

  console.log("services > editActivityGroup called...");
  return new Promise(async (resolve, reject) => {
    try {
      
          console.log("SS:: countryId===", user.countryCode);
          let data = collectionRef(CL_COUNTRIES)
            .doc(user.countryCode)
            .collection(IMT_ACTIVITY_GROUP)
            .doc(docID);
           data
            .get()
            .then((docRef) => {
             setActivityGroupHistory(data, docRef.data());
              data.update({ 
              actionBy : user.workerId,
              actionTS : new Date().toISOString(),
              actionType : "Project File Upload",
              hasProjectData: true });
              resolve(data);
            })
            .catch((err) => {
              console.error("processing setActivityGroupHistory err===", err);
              reject(err);
            });
        
    } catch (error) {
      console.error("in services > editActivityGroup, Err===", error);
      reject(error);
    }
  });
};
/**
 * function to upload files to storage bucket for global ops survey.
 * returns an array of file path.
 * @param {JsFileObj} fileObj
 */

export const uploadITContractorFiles = (fileObjList) => {
  console.log("services > uploadITContractorFiles called...");
  return new Promise(async (resolve, reject) => {
    try {
      let filePath = '';
      for (let index = 0; index < fileObjList.length; index++) {
        const fileObj = fileObjList[index];
        const date = moment().format(dateConfig.format6);
        const timeStamp = moment().format(dateConfig.format4);
        const uuid = uuidv4().replace(/-/g, "");
        const temp = fileObj.name.split(".");
        const extention = temp[temp.length - 1];
        
        const name = `IMTime_ContingentWorkers_${timeStamp}.${extention}`;
     
       let fileName = `${name}`;
       let fileUploadRef = storageRef.child(fileName);
        await fileUploadRef
          .put(fileObj)
          .then(function (snapshot) {
            console.log("File uploaded successfully as=", fileName);
            filePath = fileName;
          })
          .catch((err) => {
            console.log("File upload error as=", err);
            reject(err);
          });
      }
      resolve(filePath);
    } catch (error) {
      console.error("in services > uploadIdeaFiles, Err===", error);
      reject(error);
    }
  });
};
/**
 * function to upload files to storage bucket for global ops survey.
 * returns an array of file path.
 * @param {JsFileObj} fileObj
 */

export const uploadWarehouseProjectFiles = (fileObjList, projectName) => {
  console.log("services > uploadProjectFiles called...");
  return new Promise(async (resolve, reject) => {
    try {
      let filePath = '';
      for (let index = 0; index < fileObjList.length; index++) {
        const fileObj = fileObjList[index];
        const date = moment().format(dateConfig.format6);
        const timeStamp = moment().format(dateConfig.format4);
        const uuid = uuidv4().replace(/-/g, "");
        const temp = fileObj.name.split(".");
        const extention = temp[temp.length - 1];
        const ProName = projectName.replace(/ /g, "_")
        const name = `warehouseProject_${ProName}_${timeStamp}.${extention}`;
     
       let fileName = `${name}`;
       let fileUploadRef = storageImwarehouseRefUpload.child(fileName);
        await fileUploadRef
          .put(fileObj)
          .then(function (snapshot) {
            console.log("File uploaded successfully as=", fileName);
            filePath = fileName;
          })
          .catch((err) => {
            console.log("File upload error as=", err);
            reject(err);
          });
      }
      resolve(filePath);
    } catch (error) {
      console.error("in services > uploadIdeaFiles, Err===", error);
      reject(error);
    }
  });
};
/**
 * function to upload files to storage bucket for global ops survey.
 * returns an array of file path.
 * @param {JsFileObj} fileObj
 */

export const uploadIdeaFiles = (fileObjList, workerId) => {
  console.log("services > uploadIdeaFiles called...");
  return new Promise(async (resolve, reject) => {
    try {
      let filePathArray = [];
      for (let index = 0; index < fileObjList.length; index++) {
        const fileObj = fileObjList[index];
        const date = moment().format(dateConfig.format6);
        const timeStamp = moment().format(dateConfig.format4);
        const uuid = uuidv4().replace(/-/g, "");
        const temp = fileObj.name.split(".");
        const extention = temp[temp.length - 1];
        const name = `globalOps_File_${uuid}_${timeStamp}.${extention}`;
        let fileName = `${storageBasePathIdea}${date}/${name}`;
        //let fileUploadRef = storageRef.child(fileName);
        let fileUploadRef = storageGlobalRefUpload.child(fileName);
        await fileUploadRef
          .put(fileObj)
          .then(function (snapshot) {
            console.log("File uploaded successfully as=", fileName);
            filePathArray.push(fileName);
          })
          .catch((err) => {
            console.log("File upload error as=", err);
            reject(err);
          });
      }
      resolve(filePathArray);
    } catch (error) {
      console.error("in services > uploadIdeaFiles, Err===", error);
      reject(error);
    }
  });
};
/**
 * function to get a list of download urls using file path array.
 */
export const getFileUrl = (fileArray) => {
  console.log("services > getFileUrl called...");
  return new Promise(async (resolve, reject) => {
    try {
      let urlArray = [];
      for (let index = 0; index < fileArray.length; index++) {
        const file = fileArray[index];
        await storageGlobalRefUpload
          .child(file)
          .getDownloadURL()
          .then((url) => {
            urlArray.push(url);
            console.log("File url fetched for file = ", file);
          })
          .catch((err) => {
            console.log("getFileUrl error as=", err);
            reject(err);
          });
      }
      resolve(urlArray);
    } catch (error) {
      console.error("in services > uploadIdeaFiles, Err===", error);
      reject(error);
    }
  });
};
/**
 * function to get a list of download urls using file path array.
 */
export const getProjectFileUrl = (fileArray) => {
  console.log("services > getProjectFileUrl called...");
  return new Promise(async (resolve, reject) => {
    try {
      let urlArray = [];
      for (let index = 0; index < fileArray.length; index++) {
        const file = fileArray[index];
       await storageImwarehouseRefUpload
       //await storageGlobalRefUpload
          .child(file)
          .getDownloadURL()
          .then((url) => {
            urlArray.push(url);
            console.log("File url fetched for file = ", file);
          })
          .catch((err) => {
            console.log("getFileUrl error as=", err);
            reject(err);
          });
      }
      resolve(urlArray);
    } catch (error) {
      console.error("in services > uploadIdeaFiles, Err===", error);
      reject(error);
    }
  });
};

/**
 * function to download a CWK Template file from storage bucket.
 */
export const downloadCwkCsv = () => {
  console.log("services > uploadCwkCsv called...");
  return new Promise((resolve, reject) => {
    try {
      // Filename should be the storage bucket path of the template csv file.
      let fileName = `${storageBasePath}Template.csv`;
      storageRef
        .child(fileName)
        .getDownloadURL()
        .then(function (url) {
          console.log("CWK Template url=", url);
          resolve(url);
        })
        .catch(function (err) {
          console.log("error downloading Cwk Template!");
          reject(err);
        });
    } catch (error) {
      console.error("in services > downloadCwkCsv, Err===", error);
      reject(error);
    }
  });
};

/**
 * fn amend country record with last recorded contingent worker id.
 * @param {String} - country name as per the database
 * @param {String} - workerId of the contingent worker
 * @return: Promise - return the promise with country doc ref
 */
export const updateLastCwkId = (countryDocId, cwkId) => {
  console.log("services > updateLastCwkId called...");
  return new Promise((resolve, reject) => {
    try {
      countriesRef()
        .doc(countryDocId)
        .update({ lastCwkId: cwkId.toString() })
        .then((docRef) => {
          resolve(docRef);
        })
        .catch((err) => {
          console.error("in services > updateLastCwkId, err===", err);
          reject(err);
        });
    } catch (error) {
      console.error("in services > updateLastCwkId, Err===", error);
      reject(error);
    }
  });
};

/**
 * fn get the latest contingent worker id based on country.
 * @param {String} - country name as per the database
 * @return: Promise - return the promise with new workerId.
 */
export const getNewCwkId = (country) => {
  console.log("services > getNewCwkId: called...");
  return new Promise((resolve, reject) => {
    return countriesRef()
      .where("countryName", "==", country)
      .limit(1)
      .get()
      .then((querySnapshot) => {
        if (
          querySnapshot.docs &&
          querySnapshot.docs.length > 0 &&
          !isNaN(querySnapshot.docs[0].data().tempWorkerIdPrefix)
        ) {
          // let result = {"id": querySnapshot.docs[0].id, "value": querySnapshot.docs[0].data().lastCwkId};
          let result = querySnapshot.docs[0].data().lastCwkId;
          if (!result && querySnapshot.docs[0].data().tempWorkerIdPrefix) {
            result = querySnapshot.docs[0].data().tempWorkerIdPrefix;
            result = result.toString().padEnd(CWK_ID_LENGTH, "0");
          }
          result = (parseInt(result) + 1)
            .toString()
            .padStart(CWK_ID_LENGTH, "0");
          updateLastCwkId(querySnapshot.docs[0].id, result);
          result = result + "," + querySnapshot.docs[0].id;
          resolve(result);
        } else {
          console.log("services > getNewCwkId: Country not found!");
          reject("Country not found!");
        }
      })
      .catch((err) => {
        console.error("services > getCountryCode, err===" + err);
        reject("Err in services > getCountryCode::", err);
      });
  });
};

/**
 * fn for fetching worker details.
 * @param {string} - employee ID number
 * @return: Promise - return the promise with worker details
 */
export const getUserDetails = async (empId) => {
  return new Promise((resolve, reject) => {
    try {
      return workersRef()
        .doc(empId)
        .get()
        .then((documentSnapshot) => {
          let emp = documentSnapshot.data();
          // No check for deleted employee, as it will be inactive.
          // if(emp[IS_DELETED] == true){
          //   reject("Employee is Deleted");
          // } else{
          resolve(documentSnapshot);
          // }
        })
        .catch((err) => {
          console.error("in services > getUserDetails, err===", err);
          reject(err);
        });
    } catch (error) {
      console.error(
        "in services > getUserDetails: Err in firestore query...",
        error
      );
      reject(error);
    }
  });
};

/**
 * fn for fetching employee details after google authentication.
 * @param {string} - employee email
 * @return: Promise - return the promise with worker details
 *                  - resolve with null to remove invalid successfull user from authentication db.
 */
export const getDetailsByEmail = async (empEmail) => {
  console.log("services > getDetailsByEmail =====", empEmail);
  return new Promise((resolve, reject) => {
    try {
      console.log("empEmail.indexOf(AUTH_VALID_EMAIL) < 0",empEmail.indexOf(AUTH_VALID_EMAIL) < 0)
      // if (empEmail.indexOf(AUTH_VALID_EMAIL) < 0) {
      //   resolve(null);
      // } else {
        return workersRef()
          .where(EMAIL, EQUALS, empEmail)
          .where(IS_DELETED, NOT_EQUALS, true)
          .limit(1)
          .get()
          .then((querySnapshot) => {
            if (querySnapshot.docs && querySnapshot.docs.length > 0) {
              resolve(querySnapshot.docs[0]);
            } else {
              // user record not found in DB.
              resolve(false);
            }
          })
          .catch((err) => {
            console.error("in services > getDetailsByEmail, err===" + err);
            reject(err);
          });
     // }
    } catch (error) {
      console.error(
        "in services > getUserDetails: Err in firestore query...",
        error
      );
      reject(error);
    }
  });
};

/**
 * fn for adding new punch details.
 * @param {Object} - object containing all punch details
 * @param {Object} - object containing last punch activity - Optional
 * @return: Promise - return the promise with new firestore document ref
 */
export const addPunch = (punch, isSupervisor, isPersist) => {
  console.log("services > addPunch called...");
  return new Promise((resolve, reject) => {
    try {
      const punchInLocalTs = punch.inLocalTS;
      const punchOutLocalTs = punch.outLocalTS;
      let punchId = uuidv4().replace(/-/g, "");
      let weekNumber = getWeekNumber(punchInLocalTs);
      // console.log("weekNumberweek", weekNumber);

      let duration = 0.0;
      if (punchOutLocalTs) {
        weekNumber = getWeekNumber(punchOutLocalTs);
        let hours = getDurationInHours(punchInLocalTs, punchOutLocalTs);
        duration = parseFloat(hours);
      }
      punch.weekNumber = weekNumber;
      punch.duration = duration;

      punchesRef()
        //.add(punch)
        .doc(punchId)
        .set(punch)
        .then(async (docRef) => {
          if (!isSupervisor) {
            if (punch.activityName == "IN") {
              await updateLastPunchId(
                punch.workerId,
                punch.activityGroup,
                punch.jobProjectInfo,
                punchId,
                isPersist,
                punch.activityName,
                punch.inLocalTS
              );
            } else {
              await updateLastPunchId(
                punch.workerId,
                punch.activityGroup,
                punch.jobProjectInfo,
                punchId,
                isPersist,
                punch.activityName
              );
            }
          } else {
            // updateLastPunchId(
            //   punch.workerId,
            //   punch.activityGroup,
            //   punch.jobProjectInfo,
            //   false,
            //   isPersist
            // );
            if (punch.activityName == "IN") {
              await updateLastPunchId(
                punch.workerId,
                punch.activityGroup,
                punch.jobProjectInfo,
                false,
                isPersist,
                false,
                punch.inLocalTS
              );
            } else {
              await updateLastPunchId(
                punch.workerId,
                punch.activityGroup,
                punch.jobProjectInfo,
                false,
                isPersist
              );
            }
          }
          console.log("addPunch added with id=", punchId);

          resolve(punchId);
        })
        .catch((err) => {
          console.error("in services > addPunch, err::", err);
          reject(err);
        });
    } catch (error) {
      console.error("in services > addPunch, Err::", error);
      reject(error);
    }
  });
};

/**
 * 
 * @param {workerId} workerId 
 * @returns worker Activity details
 */
export const getWorkerActivity = (workerId) =>{
  return new Promise((resolve, reject) =>{
    try{
     workersRef()
      .doc(workerId)
      .collection("workerActivity")
      .doc(workerId).get().then((doc)=>{
        console.log("workerDoc",doc.data())
        resolve(doc);
      });
    }catch(err){
      reject(err);
      console.log("error fetching Worker Activity", err)
    }
  })
}

/**
 * 
 * @param {workerId} workerId 
 * @returns worker Activity details
 */
export const updateWorkerLastPunchId = (workerId, lastPunchId) =>{
  return new Promise( async (resolve, reject) =>{
    try{
      console.log("in services updateWorkerLastPunchId");
    if(workerId && lastPunchId){
      let workerDocRef =  workersRef().doc(workerId);
      workerDocRef.get().then( async doc =>{
        if(doc.exists){
          let docData = doc.data();
          await workerDocRef.collection('workerHistory').add(docData);
          await workerDocRef.set({
            actionBy : "support",
            actionTS : new Date().toISOString(),
            lastPunchId: lastPunchId
          },{merge:true})
          resolve(true);
        }
      })

      let docRef = workersRef().doc(workerId).collection("workerActivity").doc(workerId);
      docRef.get().then( async doc =>{
        if(doc.exists){
          await docRef.set({
            actionBy : "support",
            actionTS : new Date().toISOString(),
            lastPunchId: lastPunchId
          },{merge:true})
          resolve(true);
        }else{
          resolve(false);
        }
      })
      }else{
        resolve(false);
      }
    }catch(err){
      reject(err);
      console.log("error updating Worker last punch id", err)
    }
  })
}

/**
 * 
 * @param {workerId} workerId 
 * @param {property} property
 * @param {value} value 
 * @returns worker Activity details
 */
export const updateWorkerProperty = (workerId, updatedProperties) =>{
  return new Promise( async (resolve, reject) =>{
    try{
      console.log("in services updateWorkerProperty");
    if(workerId && updatedProperties){
      let workerDocRef =  workersRef().doc(workerId);
      workerDocRef.get().then( async doc =>{
        if(doc.exists){
          let docData = doc.data();
          await workerDocRef.collection('workerHistory').add(docData);
          await workerDocRef.set({
            actionBy : "support",
            actionTS : new Date().toISOString(),
            actionType : EDIT,
            ...updatedProperties
          },{merge:true})
          resolve(true);
        }
      })
      }else{
        resolve(false);
      }
    }catch(err){
      reject(err);
      console.log("error updating Worker property", err)
    }
  })
}

/**
 * 
 * @param {workerId} workerId 
 * @returns worker Activity details
 */
export const getWorkerDetails = (workerId) =>{
  return new Promise((resolve, reject) =>{
    try{
      const workerRef = workersRef().doc(workerId);
      workerRef.get().then(workerDataDoc => {
        resolve(workerDataDoc);
      })
    }catch(err){
      reject(err);
      console.log("error fetching Worker Activity", err)
    }
  })
}

/**
 * fn amend worker record with last recorded punch id.
 * @param {String} - employee ID number
 * @param {String} - punch record doc id
 * @return: Promise - return the promise with worker doc ref
 */
const updateLastPunchId = (
  workerId,
  activityGroup,
  jobProjectInfo,
  punchId,
  ispersist,
  activityName,
  recentClockIn
) => {
  console.log("services > updateLastPunchId called...");
  return new Promise((resolve, reject) => {
    let lastActivity = LAST + activityGroup;
    let users = new Object();
    if (ispersist) {
      users[lastActivity] = jobProjectInfo;
      users.lastActGrp = activityGroup;
    }
    if (punchId) {
      users["lastPunchId"] = punchId;
    }
    if (activityName && activityName == "IN") {
      if (recentClockIn) users["clockIn"] = recentClockIn;
      users["hasMeal"] = false;
    } else if (activityName && activityGroup === MEAL) users["hasMeal"] = true;

    try {
      const data = workersRef()
        .doc(workerId)
        .collection("workerActivity")
        .doc(workerId);

      workersRef()
        .doc(workerId)
        .update(users)
        .then((docRef) => {
          users["actionTS"] = new Date().toISOString();
          users["actionBy"] = workerId;
          data
            .get()
            .then((docRef) => {
              if (docRef.exists) {
                data
                  .update(users)
                  .then((docRef) => {
                    console.log("WorkerActivty updated successfully...\n");
                    resolve(docRef);
                  })
                  .catch((err) => {
                    console.error(
                      "in services > updateWorkerActivty, err===",
                      err
                    );
                    reject(err);
                  });
              } else {
                data
                  .set(users)
                  .then((docRef) => {
                    console.log("WorkerActivty created successfully...\n");
                    resolve(docRef);
                  })
                  .catch((err) => {
                    console.log("updateLastPunchId err::" + err);
                    reject(err);
                  });
              }
            })
            .catch((err) => {
              console.log("updateLastPunchId err::" + err);
              reject(err);
            });

          // workersRef()
          //   .doc(workerId)
          //   .update(users)
          //   .then((docRef) => {
          //     resolve(docRef);
        })
        .catch((err) => {
          console.error("in services > updateLastPunchId, err===", err);
          reject(err);
        });
    } catch (error) {
      console.error("in services > updateLastPunchId, Err===", error);
      reject(error);
    }
  });
};

/**
 * fn for adding Contingent Worker.
 * @param {Object} - object containing all punch details
 * @return: Promise - return the promise with new firestore document ref
 */
export const addContingentWorker = (
  contingentWorker,
  workerscheduleData,
  gdeReceivedData,
  transportRecievedData,
  sbsReceivedData,
  crozierReceivedData,
  imTimeAccessReceivedData,
  gorpaAccessReceivedData,
  smartSortUserReceivedData,
  securebaseReceivedData
) => {
  console.log("services > addContingentWorker called...", contingentWorker);
  console.log(
    "services > addContingentWorker workerId...",
    contingentWorker.workerId
  );
  console.log("services > workerscheduleData workerId...", workerscheduleData);
  console.log("services > workerGdeData workerId...", gdeReceivedData);
  console.log("services > sbsReceivedData workerId...", sbsReceivedData);
  console.log("services > gorpaAccessReceivedData workerId...", gorpaAccessReceivedData);
  console.log(
    "services > crozierReceivedData workerId...",
    crozierReceivedData
  );
  console.log("services > securebaseReceivedData workerId...", securebaseReceivedData);
  return new Promise((resolve, reject) => {
    try {
      // ENMO-930 adding isDeleted flag for all workers.
      contingentWorker.isDeleted = false;
      contingentWorker.workerType = "temp";
      contingentWorker.version = 1;
      const workersColRef = workersRef().doc(
        contingentWorker.workerId.toString()
      );
      const idExist = countriesRef()
        .where("workerId", "==", contingentWorker.workerId)
        .limit(1);

      idExist
        .get()
        .then((querySnapshot) => {
          console.log("idExist =", querySnapshot.docs.length);
          if (querySnapshot.docs.length > 0) {
            console.log("WORKER ALREADY EXIST!!!");
            resolve(false);
          } else {
            console.log("WORKER TO BE ADDED NOW!!!");
            // resolve(true);  //DELETE
            workersColRef
              .set(contingentWorker)
              .then(() => {
                // resolve(true);
                if (workerscheduleData !== null) {
                  saveWorkerScheduleData(
                    contingentWorker,
                    workerscheduleData,
                    workersColRef
                  );
                }
                if (gdeReceivedData !== null) {
                  saveWorkerGdeData(
                    contingentWorker,
                    gdeReceivedData,
                    workersColRef
                  );
                }
                if (transportRecievedData !== null) {
                  saveWorkerTransportData(
                    contingentWorker,
                    transportRecievedData,
                    workersColRef
                  );
                }
                if (sbsReceivedData != null) {
                  saveWorkerSBSData(
                    contingentWorker,
                    sbsReceivedData,
                    workersColRef
                  );
                }
                
                if (smartSortUserReceivedData != null) {
                  saveWorkerSmartSortUserData(
                    contingentWorker,
                    smartSortUserReceivedData,
                    workersColRef
                  );

                 }
               if (crozierReceivedData != null) {
                  saveWorkerCrozierData(
                    contingentWorker,
                    crozierReceivedData,
                    workersColRef
                  );
                }
                if (imTimeAccessReceivedData != null) {
                  saveWorkerIMTimeRoleData(
                    contingentWorker,
                    imTimeAccessReceivedData,
                    workersColRef
                  );
                }
                if (gorpaAccessReceivedData != null){
                  saveWorkerGorpaData(
                    contingentWorker,
                    gorpaAccessReceivedData,
                    workersColRef
                  );
                }
                if (securebaseReceivedData != null) {
                  saveWorkerSecurebaseData(
                    contingentWorker,
                    securebaseReceivedData,
                    workersColRef
                  );
                }
                resolve(contingentWorker);
              })
              .catch((err) => {
                console.error("in services > addContingentWorker, err::", err);
                reject(err);
              });
          }
        })
        .catch((err) => {
          console.error("in services > addContingentWorker, err::", err);
          reject(err);
        });
    } catch (error) {
      console.error("in services > addContingentWorker, Err::", error);
      reject(error);
    }
  });
};

export const saveWorkerGdeData = async (
  contingentWorker,
  data,
  workersColRef
) => {
  console.log(
    "services > workerSchedule > saveWorkerScheduleEntries called.for data..",
    data
  );

  return new Promise((res, rej) => {
    try {
      if (data == null) {
        return rej(new Error("Data is null"));
      }

      workersColRef
        .collection("workerRoles")
        .doc("gde")
        .set(data, { merge:true })
        .then(() => {
          console.log("Document successfully written to firestore!");
          res(true);
        })
        .catch((err) => {
          console.error("in services > updateWorker, err::", err);
          rej(err);
        });
    } catch (error) {
      console.error(
        "in services > workerSchedule > saveWorkerScheduleEntries, err===" +
        error
      );
      rej(error);
    }
  });
};

export const saveWorkerTransportData = async (
  contingentWorker,
  data,
  workersColRef
) => {
  console.log(
    "services > workerRoles > saveWorkerTransportData called.for data..",
    data
  );

  return new Promise((res, rej) => {
    try {
      if (data == null) {
        return rej(new Error("Data is null"));
      }

      workersColRef
        .collection("workerRoles")
        .doc("transportation")
        .set(data, { merge:true })
        .then(() => {
          console.log("Document successfully written to firestore!");
          res(true);
        })
        .catch((err) => {
          console.error("in services > updateWorker, err::", err);
          rej(err);
        });
    } catch (error) {
      console.error(
        "in services > workerRoles > saveWorkerTransportData, err===" + error
      );
      rej(error);
    }
  });
};

export const saveWorkerSmartSortUserData = async (
  contingentWorker,
  data,
  workersColRef
) => {
  console.log(
    "services > workerRoles > saveWorkerSmartSortUserDatacalled.for data..",
    data
  );

  return new Promise((res, rej) => {
    try {
      if (data == null) {
        return rej(new Error("Data is null"));
      }

      workersColRef
        .collection("workerRoles")
        .doc("ONEIL")
        .set(data, { merge:true })
        .then(() => {
          console.log("Document successfully written to firestore!");
          res(true);
        })
        .catch((err) => {
          console.error("in services > updateWorker, err::", err);
          rej(err);
        });
    } catch (error) {
      console.error(
        "in services > workerRoles > saveWorkerSmartSortData, err===" + error
      );
      rej(error);
    }
  });
};
export const saveWorkerSecurebaseData = async (
  contingentWorker,
  data,
  workersColRef
) => {
  console.log(
    "services > workerRoles > saveWorkerSecurebaseData called.for data..",
    data
  );

  return new Promise((res, rej) => {
    try {
      if (data == null) {
        return rej(new Error("Data is null"));
      }

      workersColRef
        .collection("workerRoles")
        .doc("securebase")
        .set(data, { merge:true })
        .then(() => {
          console.log("Document successfully written to firestore!");
          res(true);
        })
        .catch((err) => {
          console.error("in services > updateWorker, err::", err);
          rej(err);
        });
    } catch (error) {
      console.error(
        "in services > workerRoles > saveWorkerSecurebaseData, err===" + error
      );
      rej(error);
    }
  });
};
export const saveWorkerSBSData = async (
  contingentWorker,
  data,
  workersColRef
) => {
  console.log(
    "services > workerRoles > saveWorkerSBSData called.for data..",
    data
  );

  return new Promise((res, rej) => {
    try {
      if (data == null) {
        return rej(new Error("Data is null"));
      }

      workersColRef
        .collection("workerRoles")
        .doc("SBS")
        .set(data, { merge:true })
        .then(() => {
          console.log("Document successfully written to firestore!");
          res(true);
        })
        .catch((err) => {
          console.error("in services > updateWorker, err::", err);
          rej(err);
        });
    } catch (error) {
      console.error(
        "in services > workerRoles > saveWorkerSBSData, err===" + error
      );
      rej(error);
    }
  });
};

export const saveWorkerCrozierData = async (
  contingentWorker,
  data,
  workersColRef
) => {
  console.log(
    "services > workerRoles > saveWorkerCrozierData called.for data..",
    data
  );

  return new Promise((res, rej) => {
    try {
      if (data == null) {
        return rej(new Error("Data is null"));
      }

      workersColRef
        .collection("workerRoles")
        .doc("crozier")
        .set(data, { merge:true })
        .then(() => {
          console.log("Document successfully written to firestore!");
          res(true);
        })
        .catch((err) => {
          console.error("in services > updateWorker, err::", err);
          rej(err);
        });
    } catch (error) {
      console.error(
        "in services > workerRoles > saveWorkerCrozierData, err===" + error
      );
      rej(error);
    }
  });
};

export const saveWorkerIMTimeRoleData = async (
  contingentWorker,
  data,
  workersColRef
) => {
  console.log(
    "services > workerRoles > saveWorkerIMTimeRoleData called.for data..",
    data
  );

  return new Promise((res, rej) => {
    try {
      if (data == null) {
        return rej(new Error("Data is null"));
      }

      workersColRef
        .collection("workerRoles")
        .doc("timeRole")
        .set(data, { merge:true })
        .then(() => {
          console.log("Document successfully written to firestore!");
          res(true);
        })
        .catch((err) => {
          console.error("in services > updateWorker, err::", err);
          rej(err);
        });
    } catch (error) {
      console.error(
        "in services > workerRoles > saveWorkerCrozierData, err===" + error
      );
      rej(error);
    }
  });
};

export const saveWorkerGorpaData = async(
  contingentWorker,
  data,
  workersColRef
) => {
  console.log(
    "services > workerRoles > saveWorkerGorpaData called.for data..",
    data
  );

  return new Promise((res, rej) => {
    try {
      if (data == null) {
        return rej(new Error("Data is null"));
      }

      workersColRef
        .collection("workerRoles")
        .doc("gorpa")
        .set(data, { merge:true })
        .then(() => {
          console.log("Document successfully written to firestore!");
          res(true);
        })
        .catch((err) => {
          console.error("in services > updateWorker, err::", err);
          rej(err);
        });
    } catch (error) {
      console.error(
        "in services > workerRoles > saveWorkerGorpaData, err===" + error
      );
      rej(error);
    }
  });
};

export const saveWorkerLogITData = async(
  contingentWorker,
  data,
  workersColRef
) => {
  console.log(
    "services > workerRoles > saveWorkerLogITData called.for data..",
    data
  );

  return new Promise((res, rej) => {
    try {
      if (data == null) {
        return rej(new Error("Data is null"));
      }

      workersColRef
        .collection("workerRoles")
        .doc("logIT")
        .set(data, { merge:true })
        .then(() => {
          console.log("Document successfully written to firestore!");
          res(true);
        })
        .catch((err) => {
          console.error("in services > updateWorker, err::", err);
          rej(err);
        });
    } catch (error) {
      console.error(
        "in services > workerRoles > saveWorkerLogITData, err===" + error
      );
      rej(error);
    }
  });
};

export const saveWorkerScheduleData = async (
  contingentWorker,
  data,
  workersColRef
) => {
  console.log(
    "services > workerSchedule > saveWorkerScheduleEntries called..."
  );
  return new Promise((res, rej) => {
    try {
      if (data == null) {
        return rej(new Error("Data is null"));
      }
      workersColRef
        .collection(workersSchedule)
        .doc(contingentWorker.workerId.toString())
        .set(data, { merge:true })
        .then(() => {
          console.log("Document successfully written to firestore!");
          res(true);
        })
        .catch((err) => {
          console.error("in services > updateWorker, err::", err);
          rej(err);
        });
    } catch (error) {
      console.error(
        "in services > workerSchedule > saveWorkerScheduleEntries, err===" +
        error
      );
      rej(error);
    }
  });
};

/**
 * fn for editing  Contingent Worker.
 * @param {Object} - object containing all punch details
 * @return: Promise - return the promise with new firestore document ref
 */
export const editContingentWorker = (
  contingentWorker,
  workerscheduleData,
  gdeReceivedData,
  transportRecievedData,
  sbsReceivedData,
  crozierReceivedData,
  imTimeAccessReceivedData,
  gorpaAccessReceivedData,
  smartSortUserReceivedData,
  securebaseReceivedData,
  
) => {
  console.log("services > editContingentWorker called...");
  console.log(
    "services > editContingentWorker workerscheduleData...",
    workerscheduleData
  );
  return new Promise((resolve, reject) => {
    try {
      workersRef()
        .doc(contingentWorker.workerId)
        .get()
        .then((docRef) => {
          if (docRef.exists) {
            console.log("docObject-----" + docRef.id);
            let version;
            if (docRef.data().version) {
              version = docRef.data().version + 1;
            } else {
              version = 2;
            }
            contingentWorker.version = version;
            setWorkerHistory(docRef.data(), docRef.id);
            updateWorker(contingentWorker, docRef.id);
            if (
              workerscheduleData !== null &&
              workerscheduleData !== undefined
            ) {
              updateWorkerSchedule(
                contingentWorker,
                workerscheduleData,
                docRef.id
              );
            }

            if (gdeReceivedData !== null && gdeReceivedData !== undefined) {
              saveWorkerGdeData(
                contingentWorker,
                gdeReceivedData,
                workersRef().doc(contingentWorker.workerId.toString())
              );
            }

            if (
              transportRecievedData !== null &&
              transportRecievedData !== undefined
            ) {
              saveWorkerTransportData(
                contingentWorker,
                transportRecievedData,
                workersRef().doc(contingentWorker.workerId.toString())
              );
            }

            if (sbsReceivedData != null && sbsReceivedData != undefined) {
              saveWorkerSBSData(
                contingentWorker,
                sbsReceivedData,
                workersRef().doc(contingentWorker.workerId.toString())
              );
            }
            if (
              crozierReceivedData != null &&
              crozierReceivedData != undefined
            ) {
              saveWorkerCrozierData(
                contingentWorker,
                crozierReceivedData,
                workersRef().doc(contingentWorker.workerId.toString())
              );
            }
            if (
              imTimeAccessReceivedData != null &&
              imTimeAccessReceivedData != undefined
            ) {
              saveWorkerIMTimeRoleData(
                contingentWorker,
                imTimeAccessReceivedData,
                workersRef().doc(contingentWorker.workerId.toString())
              );
            }
            if (
              gorpaAccessReceivedData != null &&
              gorpaAccessReceivedData != undefined
            ){
              saveWorkerGorpaData(
                contingentWorker,
                gorpaAccessReceivedData,
                workersRef().doc(contingentWorker.workerId.toString())
              );
            }
            if (
              smartSortUserReceivedData != null &&
              smartSortUserReceivedData != undefined
            ) {
              saveWorkerSmartSortUserData(
                contingentWorker,
                smartSortUserReceivedData,
                workersRef().doc(contingentWorker.workerId.toString())
              );
            }
            if (securebaseReceivedData != null && securebaseReceivedData != undefined) {
              saveWorkerSecurebaseData(
                contingentWorker,
                securebaseReceivedData,
                workersRef().doc(contingentWorker.workerId.toString())
              );
            }

            resolve(true);
          } else {
            console.log("Worker does not exists");
            resolve(false);
          }
        })
        .catch((err) => {
          console.error("in services > editContingentWorker, err::", err);
          reject(err);
        });
    } catch (error) {
      console.error("in services > editContingentWorker, Err::", error);
      reject(error);
    }
  });
};

/**
 * fn created to take backup of Workers collection in workerHistory collection
 * @param {Object} - object containing all punch details
 * @return: Promise - return the promise with new firestore document ref
 */
export const setWorkerHistory = (worker, workerId) => {
  console.log("services > setWorkerHistory called...");
  return new Promise((resolve, reject) => {
    try {
      workersRef()
        .doc(workerId)
        .collection(workerHistory)
        .add(worker)
        .then((docRef) => {
          resolve(docRef);
        })
        .catch((err) => {
          console.error("in services > setWorkerHistory, err::", err);
          reject(err);
        });
    } catch (error) {
      console.error("in services > setWorkerHistory, Err::", error);
      reject(error);
    }
  });
};

/**
 * fn for updating current workers details in workers db.
 * @param {Object} - object containing all punch details
 * @return: Promise - return the promise with new firestore document ref
 */
export const updateWorker = (worker, workerId) => {
  console.log("services > updateWorker called...");
  return new Promise((resolve, reject) => {
    try {
      workersRef()
        .doc(workerId)
        .set(worker, { merge: true })
        .then((docRef) => {
          resolve(docRef);
        })
        .catch((err) => {
          console.error("in services > updateWorker, err::", err);
          reject(err);
        });
    } catch (error) {
      console.error("in services > updateWorker, Err::", error);
      reject(error);
    }
  });
};

/**
 * 
 * @param {*} loggedInWorkerId 
 * @param {*} delegateWorkers 
 * @param {*} addDelegate 
 * @param {*} removeDelegate 
 * @returns 
 */
 export const assignDelegateManagers = async ( loggedInWorkerId, delegateWorkers,addDelegate,removeDelegate) => {
  let allWorkerIds = [... new Set([...removeDelegate,...addDelegate,loggedInWorkerId])];
  console.log("services add",loggedInWorkerId,allWorkerIds);
   return new Promise((res, rej) => {
    try {
      workersRef()
      .where("workerId",IN,allWorkerIds).get()
      .then( snapshots => {
        if (snapshots.size > 0) {
          snapshots.forEach(async (workerDoc) => {
            if(addDelegate && addDelegate.length>0 && addDelegate.includes(workerDoc.id)){
              await workersRef().doc(workerDoc.id).update("delegateFor", firebase.firestore.FieldValue.arrayUnion(loggedInWorkerId))
            }else if(removeDelegate && removeDelegate.length>0 && removeDelegate.includes(workerDoc.id)){
              await workersRef().doc(workerDoc.id).update("delegateFor", firebase.firestore.FieldValue.arrayRemove(loggedInWorkerId))
            }else if(loggedInWorkerId && loggedInWorkerId === workerDoc.id){
              let workerDataToBeUpdated = {
                "delegateMgrId":[...delegateWorkers]
              }
              //await updateWorker(workerDataToBeUpdated,loggedInWorkerId)
              await workersRef().doc(workerDoc.id).update("delegateMgrId", [...delegateWorkers])
            }
          })
        }
        res(snapshots)
      })
        .catch((err) => {
          console.error("in services > assignDelegateManagers, err::", err);
          rej(err);
        });
    } catch (err) {
      console.error("updating delegateFor failed", err);
      rej(err);
    }
  })
}

/**
 * fn for updating current workers details in workers db.
 * @param {Object} - object containing all punch details
 * @return: Promise - return the promise with new firestore document ref
 */
export const updateWorkerSchedule = (
  contingentWorker,
  workerscheduleData,
  workerId
) => {
  console.log("services > workerscheduleData ...", workerscheduleData);
  console.log("services > workerId ...", workerId);
  return new Promise((resolve, reject) => {
    try {
      const workersColRef = workersRef().doc(
        contingentWorker.workerId.toString()
      );
      const workerScheduleRef = workersColRef
        .collection(workersSchedule)
        .doc(workerId);
      //var docRef = db.collection("cities").doc("SF");
      workerScheduleRef
        .get()
        .then((doc) => {
          if (doc.exists) {
            console.log("Document data:", doc.data());
            console.log(
              "newworkerscheduleData:",
              workerscheduleData,
              "",
              workerscheduleData.workingHoursEnabled
            );
            // if(! deepEqual(workerscheduleData,oldWorkerSchedule) ) {
            //   if ( workerscheduleData.workingHoursEnabled ) {
            //save in workerScheduleHistory collection
            workerScheduleRef
              .collection(workersScheduleHistory)
              .doc()
              .set(doc.data())
              .then(() => {
                console.log(
                  "Document  written to workersScheduleHistory succesfully!"
                );
                resolve(true);
              })
              .then(() => {
                // doc.data() will be undefined in this case
                //update the workerSchedule collection
                workersColRef
                  .collection(workersSchedule)
                  //workersRef()
                  .doc(workerId)
                  .set(workerscheduleData, { merge: false })
                  .then((docRef) => {
                    resolve(docRef);
                  })
                  .catch((err) => {
                    console.error(
                      "in services > updateWorkerSchedule, err::",
                      err
                    );
                    reject(err);
                  });
              })
              .catch((err) => {
                console.error("in services > updateWorker, err::", err);
                reject(err);
              });
            // }
            // }
          } else {
            workersColRef
              .collection(workersSchedule)
              //workersRef()
              .doc(workerId)
              .set(workerscheduleData, { merge: false })
              .then((docRef) => {
                resolve(docRef);
              })
              .catch((err) => {
                console.error("in services > updateWorker, err::", err);
                reject(err);
              });
          }
        })
        .catch((error) => {
          console.log("Error getting document:", error);
        });
    } catch (error) {
      console.error("in services > updateWorker, Err::", error);
      reject(error);
    }
  });
};

/**
 * fn for fetching punch details.
 * @param {String} - punch record doc id
 * @return: Promise - return the promise with punch details
 */
export const getPunchData = (punchId) => {
  console.log("services > getPunchData called...");
  return new Promise((resolve, reject) => {
    try {
      punchesRef()
        .doc(punchId)
        .get()
        .then((doc) => {
          resolve(doc);
        })
        .catch((err) => {
          console.error("in services > getPunchData, err===" + err);
          reject(err);
        });
    } catch (error) {
      console.error("in services > getPunchData, Err===", error);
      reject(error);
    }
  });
};

/**
 * fn for fetching location details.
 * @return: Promise - return the promise with location details
 */
export const getLocationDetails = async (countryCode, alternateCountryCode) => {
  console.log("services > getLocationDetails called...", countryCode);
  return new Promise((res, rej) => {
    try {
      let CountryCode = countryCode
        ? countryCode !== "testCountry"
          ? countryCode.toLowerCase()
          : countryCode
        : null;
      let query = collectionGroup(BUILDINGS);
      let countriesForLocations = [CountryCode];
      if (alternateCountryCode)
        countriesForLocations.push(alternateCountryCode);
      if (CountryCode && CountryCode !== "testCountry")
        query = query.where(COUNTRYCODE, IN, countriesForLocations);
      return query
        .get()
        .then((documentSnapshot) => {
          let locations = {};
          let defaultDistricts = [];
          const buildings = documentSnapshot.docs
            .map((doc) => ({
              id: doc.id,
              data: doc.data(),
            }))
            .filter((e) =>
              e.data.collectionName
                ? e.data.collectionName == CL_LOCATIONS
                : false
            );
          if (buildings) {
            let countryDistricts;
            let districtBuildings = [];
            let districtobj = {};
            for (let item of buildings) {
              const { id, data } = item;
              const country = data.countryCode;
              const districtName = data.districtName;
              const activityEnabled = data.activityEnabled;
              if (districtName) {
                if (
                  districtobj[districtName] &&
                  districtobj[districtName].buildings
                ) {
                  districtBuildings = districtobj[districtName].buildings;
                } else {
                  districtobj[districtName] = {};
                  districtobj[districtName].country = country;
                  districtobj[districtName].label = districtName;
                  districtobj[districtName].value = districtName;
                  districtBuildings = [];
                }
                let building = {
                  label: id,
                  value: id,
                  activityEnabled: activityEnabled,
                };
                if (building.activityEnabled === true) {
                  districtBuildings.push(building);
                }
                districtobj[districtName].buildings = districtBuildings;
              }
            }
            const districts = Object.keys(districtobj);
            for (let district of districts) {
              const districtval = districtobj[district];
              let country = districtval.country;
              if (districtval.buildings) {
                const customerSite = {
                  label: CUSTOMER_SITE,
                  value: CUSTOMER_SITE,
                };
                districtval.buildings.push(customerSite);

                const remote = {
                  label: REMOTE,
                  value: REMOTE,
                  mgrOnly: true,
                };
                districtval.buildings.push(remote);
              }
              if (country) {
                country = country.toLowerCase();
                if (locations[country]) {
                  countryDistricts = locations[country];
                } else {
                  countryDistricts = [];
                }
                countryDistricts.push(districtval);
                locations[country] = countryDistricts;
              }
              if (CountryCode === "testCountry")
                defaultDistricts.push(districtval);
            }
            if (CountryCode === "testCountry")
              locations.default = defaultDistricts;
            res(locations);
          }
        })
        .catch((error) => {
          console.error("in services > getLocationDetails, err===" + error);
          rej(error);
        });
    } catch (error) {
      console.error("in services > getLocationDetails, err===" + error);
      rej(error);
    }
  });
};

/**
 * fn for fetching Job Family details.
 * @return: Promise - return the promise with job family details
 */
export const getJobFamilyDetails = async () => {
  console.log("services > getJobFamilyDetails called...");
  return new Promise((res, rej) => {
    try {
      return collectionRef(CL_JOB_FAMILIES)
        .get()
        .then((documentSnapshot) => {
          const jobFamilies = {};
          documentSnapshot.forEach((doc) => {
            const jobFamilyData = doc.data();
            const { localNameMap, ...restJF } = jobFamilyData;
            const langKeys = Object.keys(localNameMap);
            let jobFamilyList = [];
            langKeys.forEach((lang) => {
              if (jobFamilies[lang]) {
                jobFamilyList = jobFamilies[lang];
              } else {
                jobFamilyList = [];
              }
              if (localNameMap[lang]) {
                const jobFamily = {
                  label: localNameMap[lang],
                  value: doc.id,
                  ...restJF,
                };
                jobFamilyList.push(jobFamily);
                jobFamilies[lang] = jobFamilyList;
              }
            });
          });
          res(jobFamilies);
        })
        .catch((err) => {
          console.error("in services > getJobFamilyDetails, err===" + err);
          rej(err);
        });
    } catch (error) {
      console.error("in services > getJobFamilyDetails, err===" + error);
      rej(error);
    }
  });
};

/**
 * fn for fetching Activity Group details.
 * @return: Promise - return the promise with activity group details
 */
export const getActivityGroupDetails = async () => {
  console.log("services > getActivityGroupDetails called...");
  return new Promise((res, rej) => {
    try {
      return collectionRef(CL_ACTIVITY_GROUPS)
        .get()
        .then((documentSnapshot) => {
          const activityGroups = {};
          documentSnapshot.forEach((doc) => {
            const activityGroupData = doc.data();
            const { localNameMap, ...restAG } = activityGroupData;
            const langKeys = Object.keys(localNameMap);
            let activityList = [];
            langKeys.forEach((lang) => {
              if (activityGroups[lang]) {
                activityList = activityGroups[lang];
              } else {
                activityList = [];
              }
              const activity = {
                label: localNameMap[lang],
                value: doc.id,
                ...restAG,
              };
              activityList.push(activity);
              activityGroups[lang] = activityList;
            });
          });
          res(activityGroups);
        })
        .catch((err) => {
          console.error("in services > getActivityGroupDetails, err===" + err);
          rej(err);
        });
    } catch (error) {
      console.error("in services > getActivityGroupDetails, err===" + error);
      rej(error);
    }
  });
};

export const createPunch = async (punch) => {
  return new Promise((resolve, reject) => {
    try {
      const punchInLocalTs = punch.inLocalTS;
      let weekNumber = getWeekNumber(punchInLocalTs);
      const punchOutLocalTs = punch.outLocalTS;
      // console.log("weekNumberweek", weekNumber);
      let punchId = uuidv4().replace(/-/g, "");

      let duration = 0.0;
      if (punchOutLocalTs) {
        weekNumber = getWeekNumber(punchOutLocalTs);
        let hours = getDurationInHours(punchInLocalTs, punchOutLocalTs);
        duration = parseFloat(hours);
      }
      punch.duration = duration;
      punch.weekNumber = weekNumber;

      punchesRef()
        //.add(punch)
        .doc(punchId)
        .set(punch)
        .then((docRef) => {
          console.log("addPunch added with id=", punchId);
          resolve(punchId);
        })
        .catch((err) => {
          console.error("in services > addPunch, err::", err);
          reject(err);
        });
    } catch (error) {
      console.error("in services > addPunch, Err::", error);
      reject(error);
    }
  });
};

/**
 * fn for fetching Exceptions details.
 * @return: Promise - return the promise with exceptions details
 */
export const getExceptionDetails = async () => {
  console.log("services > getExceptionDetails called...");
  return new Promise((res, rej) => {
    try {
      return collectionRef(CL_EXCEPTIONS)
        .get()
        .then((documentSnapshot) => {
          const exceptions = {};
          documentSnapshot.forEach((doc) => {
            const exceptionData = doc.data();
            const docId = doc.id.toLowerCase();
            const localNameMap = exceptionData.localNameMap;
            const langKeys = Object.keys(localNameMap);
            langKeys.forEach((lang) => {
              if (exceptions[lang]) {
                const exceptionList = exceptions[lang];
                const exception = {
                  label: localNameMap[lang],
                  value: docId,
                };
                exceptionList.push(exception);
                exceptions[lang] = exceptionList;
              } else {
                const exceptionList = [];
                const exception = {
                  label: localNameMap[lang],
                  value: docId,
                };
                exceptionList.push(exception);
                exceptions[lang] = exceptionList;
              }
            });
          });
          res(exceptions);
        })
        .catch((err) => {
          console.error("in services > getExceptionDetails, err===" + err);
          rej(err);
        });
    } catch (error) {
      console.error("in services > getExceptionDetails, err===" + error);
      rej(error);
    }
  });
};
/**
 * fn for fetching Country details.
 * @return: Promise - return the promise with Country details
 */
export const getCountryDetails = async () => {
  console.log("services > getCountryDetails called...");
  return new Promise((res, rej) => {
    try {
      return collectionRef(CL_COUNTRIES)
        .orderBy(COUNTRY_NAME, ASC)
        .get()
        .then((documentSnapshot) => {
          const countries = [];
          documentSnapshot.forEach((doc) => {
            countries.push({ id: doc.id, ...doc.data() });
          });
          res(countries);
        })
        .catch((err) => {
          console.error("in services > getCountryDetails, err===" + err);
          rej(err);
        });
    } catch (error) {
      console.error("in services > getCountryDetails, err===" + error);
      rej(error);
    }
  });
};

/**
 * fn for updating punch details.
 * @param {String} - punch record doc id
 * @param {Object} - punch
 * @param {isDeleteAction} - boolean if the action is to delete punch
 * @return: Promise - return the promise with punch details
 */
export const updatePunch = (punchId, punch, isDeleteAction, ispersist) => {
  console.log("services > updatePunch called...", ispersist);
  return new Promise(async (resolve, reject) => {
    try {
      const punchInLocalTs = punch.inLocalTS;
      let weekNumber = getWeekNumber(punchInLocalTs);
      const punchOutLocalTs = punch.outLocalTS;
      // console.log("weekNumberweek", weekNumber);

      let duration = 0.0;
      if (punchOutLocalTs) {
        weekNumber = getWeekNumber(punchOutLocalTs);
        let hours = getDurationInHours(punchInLocalTs, punchOutLocalTs);
        duration = parseFloat(hours);
      }
      punch.duration = duration;
      punch.weekNumber = weekNumber;
      punch.deviceDetails = DEVICE_DETAILS;

      await punchesRef()
        .doc(punchId)
        .get()
        .then(async (docRef) => {
          if (isDeleteAction || punch.status === APPROVED)
            await updateLastPunchId(
              docRef.data().workerId,
              docRef.data().activityGroup,
              docRef.data().jobProjectInfo,
              false,
              false
            );
          else
            await updateLastPunchId(
              punch.workerId,
              punch.activityGroup,
              punch.jobProjectInfo,
              false,
              false
            );

          punch.version = docRef.data().version + 1;
          // I-113: complete any incomplete activity if deleted.
          if (isDeleteAction) {
            punch.activityName = STATUS_OUT;
            var docData = docRef.data();
            if (
              docData.hasOwnProperty("outLocalTS") &&
              docData.outLocalTS == ""
            ) {
              const tempTS = moment(docData.inLocalTS)
                .add(1, "m")
                .format(dateConfig.format4);
              punch.outLocalTS = tempTS;
              punch.outTS = new Date(tempTS).toISOString();
              let durationHours = getDurationInHours(punchInLocalTs, tempTS);
              punch.duration = parseFloat(durationHours);
            }
          }
          await setPunchHistory(docRef.id, docRef.data());
          await editPunches(docRef.id, punch);
          resolve(true);
        })
        .catch((err) => {
          console.error("in services > updatePunch, err===" + err);
          reject(err);
        });
    } catch (error) {
      console.error("in services > updatePunch, Err===", error);
      reject(error);
    }
  });
};


/**
 * fn for updating Trip punch details.
 * @param {String} - punch record doc id
 * @param {Object} - punch
 * @param {isDeleteAction} - boolean if the action is to delete punch
 * @return: Promise - return the promise with punch details
 */
export const updateTripPunch = (punchId, punch) => {
  console.log("services > updateTripPunch called...");
  return new Promise(async (resolve, reject) => {
    try {
      const punchInLocalTs = punch.startTripLocalTS;
      const punchOutLocalTs = punch.endTripLocalTS;
      let duration = 0.0;
      if (punchOutLocalTs) {
        let hours = getDurationInHours(punchInLocalTs, punchOutLocalTs);
        duration = parseFloat(hours);
      }
         punch.tripDuration = duration;
         punch.deviceDetails = DEVICE_DETAILS;

      await punchesRef()
        .doc(punchId)
        .get()
        .then(async (docRef) => {
          let punchData = docRef.data();
          await setPunchHistory(docRef.id, punchData);
          punch.version = docRef.data().version + 1;
          let updatedPunch = {...punchData, ...punch};
          await editPunches(docRef.id, updatedPunch);
          resolve(true);
        })
        .catch((err) => {
          console.error("in services > updateTripPunch, err===" + err);
          reject(err);
        });
    } catch (error) {
      console.error("in services > updateTripPunch, Err===", error);
      reject(error);
    }
  });
};

/**
 * fn for setting punchHistory collections.
 * @param {Object} - object containing all punch details
 * @return: Promise - return the promise with new firestore document ref
 */
export const setPunchHistory = (punchId, punch) => {
  console.log("services > setPunchHistory called...");
  return new Promise((resolve, reject) => {
    try {
      return punchesRef()
        .doc(punchId)
        .collection(punchHistory)
        .add(punch)
        .then((docRef) => {
          resolve(docRef);
        })
        .catch((err) => {
          console.error("in services > setPunchHistory, err::", err);
          reject(err);
        });
    } catch (error) {
      console.error("in services > setPunchHistory, Err::", error);
      reject(error);
    }
  });
};

/**
 * fn for editing and storing updated punch details.
 * @param {Object} - object containing all punch details
 * @return: Promise - return the promise with new firestore document ref
 */
export const editPunches = (punchId, punch) => {
  console.log("services > editPunches called...");
  return new Promise((resolve, reject) => {
    try {
      punchesRef()
        .doc(punchId)
        .update(punch)
        .then((docRef) => {
          resolve(docRef);
        })
        .catch((err) => {
          console.error("in services > editPunches, err::", err);
          reject(err);
        });
    } catch (error) {
      console.error("in services > editPunches, Err::", error);
      reject(error);
    }
  });
};

/**
 * fn for approving the punch details.
 * @param {Array} - List of punchIds
 * @return: Promise - return the promise with approved punchIds
 */
export const approvePunch = (punchIds, workerId) => {
  console.log("services > updatePunch called...");
  return new Promise((resolve, reject) => {
    try {
      if (punchIds && punchIds.length > 0) {
        let date = new Date();
        const approvedPunchIds = [];
        punchIds.forEach((punchId) => {
          updatePunch(punchId, {
            status: APPROVED,
            actionBy: workerId,
            actionTS: date.toISOString(),
          })
            .then(() => {
              approvedPunchIds.push(punchId);
              return;
            })
            .catch((err) => {
              console.error(`Error in approving for punchId ${punchId}:${err}`);
              reject(err);
            });
        });
        console.log("punchIds successfully approved :", approvedPunchIds);
        resolve(approvedPunchIds);
      } else {
        console.log("punchIds null or empty");
        reject(new Error("punchIds null or empty"));
      }
    } catch (error) {
      console.error("in services > getPunchData, Err===", error);
      reject(error);
    }
  });
};

/**
 * fn for deleting the punch details.
 * @param {Array} - List of punchIds
 * @return: Promise - return the promise with deleted punchIds
 */
export const deletePunch = (punchIds, workerId) => {
  console.log("services > deletePunch called...");
  return new Promise(async (resolve, reject) => {
    try {
      if (punchIds && punchIds.length > 0) {
        let date = new Date();
        const deletePunchIds = [];
        punchIds.forEach(async (punchId) => {
          await updatePunch(
            punchId,
            {
              status: DELETED,
              actionBy: workerId,
              actionTS: date.toISOString(),
            },
            true,
            false
          )
            .then(() => {
              deletePunchIds.push(punchId);
              return;
            })
            .catch((err) => {
              console.error(`Error in deleting for punchId ${punchId}:${err}`);
              reject(err);
            });
        });
        console.log("punchIds successfully deleted :", deletePunchIds);
        resolve(deletePunchIds);
      } else {
        console.log("punchIds null or empty");
        reject(new Error("punchIds null or empty"));
      }
    } catch (error) {
      console.error("in services > getPunchData, Err===", error);
      reject(error);
    }
  });
};

/**
 * fn for deleting individual punch details.
 * @param {Array} - List of punchIds
 * @return: Promise - return the promise with deleted punchIds
 */
export const deleteIndividualPunch = (
  punchId,
  workerId,
  inLocalTS,
  outLocalTS,
  inProgressPunchFlag
) => {
  console.log("services > deleteIndividualPunch called...", workerId);
  return new Promise(async (resolve, reject) => {
    try {
      if (punchId) {
        let date = new Date();
        // check for inprogress punch
        if (inProgressPunchFlag) {
          outLocalTS = inLocalTS;
        }
        await updatePunch(
          punchId,
          {
            status: DELETED,
            actionBy: workerId,
            actionTS: date.toISOString(),
            inLocalTS,
            outLocalTS,
          },
          true,
          false
        )
          .then((doc) => {
            // deletePunchIds.push(punchId);
            console.log("punchId deleted:", punchId);
            resolve(true);
            return;
          })
          .catch((err) => {
            console.error(`Error in deleting for punchId ${punchId}:${err}`);
            reject(err);
          });
        console.log("punchIds successfully deleted :", punchId);
      } else {
        console.log("punchIds null or empty");
        reject(new Error("punchIds null or empty"));
      }
    } catch (error) {
      console.error("in services > getPunchData, Err===", error);
      reject(error);
    }
  });
};
export async function getITContractorWorkerByEmail(ids) {
  console.log("services > getITContractorWorkerByEmail= =====", ids) ;
  // don't run if there aren't any ids or a path for the collection
  try {
        if (!ids || !ids.length ) return [];
        const batches = [];
        while (ids.length) 
          {
            // firestore limits batches to 10
            const batch = ids.splice(0, 10);
            batches.push(
              workersRef()
                .where(EMAIL, IN, [...batch])
                .where(IS_DELETED, NOT_EQUALS, true)
                .get()
                .then(results => results.docs.map(result => ({...result.data() }) ))
              )
          }
          
          return Promise.all(batches)
          .then(content => content.flat());
        }
        catch (error) {
          console.error(
            "in services > getITContractorWorkerByEmail: Err in firestore query...",
            error
          );
          
        }

  }
/**
 * fn for fetching punches details for lastpunch changes
 * @param {String} - workerId
 * @param {String} - punchId
 * @return: Promise - return the promise with validlastPunch details
 */
export const setLastPunch = (workerId) => {
  console.log("services > setLastPunch called...");
  return new Promise(async (resolve, reject) => {
    // (async () => {
    try {
      return punchesRef()
        .where(WORKER_ID, EQUALS, workerId)
        .where("status", "in", [
          "new",
          "edit",
          "approved",
          "exception",
          "deleted",
        ])
        .orderBy("inLocalTS", "desc")
        .limit(1)
        .get()
        .then(async (docRef) => {
          // console.log("doc: "+ (doc));
          if (docRef.docs && docRef.docs.length > 0) {
            let data = docRef.docs[0].data();
            let id = docRef.docs[0].id;
            console.log("data for lastPunch" + " Id: " + id);
            await updateLastPunchId(
              data.workerId,
              data.activityGroup,
              data.jobProjectInfo,
              id,
              false
            );
            resolve(data);
          } else {
            console.log("data not found for last punch");
            resolve(null);
          }
        })
        .catch((err) => {
          console.error("in services > setLastPunch, err===" + err);
          reject(err);
        });
    } catch (error) {
      console.error("in services > setLastPunch, Err===", error);
      reject(error);
    }
    // })();
  });
};

/**
 * fn for fetching punch details for workerId, week.
 * @param {Array} - workerIds
 * @param {String} - startDate in yyyy-MM-dd format
 * @param {String} - endDate in yyyy-MM-dd format
 * @return: Promise - return the promise with punch details
 */
export const getWorkerPunches = (workerIds, startDate, endDate) => {
  console.log(startDate);
  console.log("services > getWorkerPunches called...");

  let startWeek = getWeekNumber(startDate);
  let endWeek = getWeekNumber(endDate);

  console.log("worker end week", endWeek, endDate,workerIds);
  console.log("worker start week", startWeek, startDate);
  return new Promise((resolve, reject) => {
    (async () => {
      try {
        let workerPunches = {};
        for (let i = 0; i < workerIds.length; i += ARRAY_LIMIT) {
          const workerIdList = workerIds.slice(i, i + ARRAY_LIMIT);
          console.log("workerIdList===", workerIdList);
          await punchesRef()
            .where(WORKER_ID, IN, workerIdList)
            .where(WEEK_NUMBER, LESS_THAN_OR_EQUAL_TO, endWeek)
            .where(WEEK_NUMBER, GREATER_THAN_OR_EQUAL_TO, startWeek)
            .orderBy(WEEK_NUMBER)
            .get()
            .then((querySnapshot) => {
              querySnapshot.forEach((doc) => {
                if (doc.data().status !== "deleted") {
                  const data = doc.data();
                  let punchList = [];
                  if (workerPunches[data.workerId]) {
                    punchList = workerPunches[data.workerId];
                  }
                  punchList.push({ id: doc.id, ...data });
                  workerPunches[data.workerId] = punchList;
                }
              });
            })
            .catch((err) => {
              console.error("in services > getWorkerPunches, err===" + err);
            });
        }
        console.log("worker punches", workerPunches);
        resolve(workerPunches);
      } catch (error) {
        console.error("in services > getWorkerPunches, Err===", error);
        reject(error);
      }
    })();
  });
};

/**
 * fn for fetching punch details for workerId, week.
 * @param {Array} - workerIds
 * @param {String} - startDate in yyyy-MM-dd format
 * @param {String} - endDate in yyyy-MM-dd format
 * @return: Promise - return the promise with punch details
 */
export const getWorkerTransportPunches = (workerIds, startDate, endDate) => {
  console.log(startDate);
  console.log("services > getWorkerTransportPunches called...");

  let startWeek = getWeekNumber(startDate);
  let endWeek = getWeekNumber(endDate);

  console.log("worker end week", endWeek, endDate,workerIds);
  console.log("worker start week", startWeek, startDate);
  return new Promise((resolve, reject) => {
    (async () => {
      try {
        let workerPunches = {};
        for (let i = 0; i < workerIds.length; i += ARRAY_LIMIT) {
          const workerIdList = workerIds.slice(i, i + ARRAY_LIMIT);
          console.log("workerIdList===", workerIdList);
          await punchesRef()
            .where(WORKER_ID, IN, workerIdList)
            .where(WEEK_NUMBER, LESS_THAN_OR_EQUAL_TO, endWeek)
            .where(WEEK_NUMBER, GREATER_THAN_OR_EQUAL_TO, startWeek)
            .orderBy(WEEK_NUMBER)
            .get()
            .then((querySnapshot) => {
              querySnapshot.forEach((doc) => {
                if (doc.data().status !== "deleted" && doc.data().tripDeleted !== true) {
                  const data = doc.data();
                  let punchList = [];
                  if (workerPunches[data.workerId]) {
                    punchList = workerPunches[data.workerId];
                  }
                  punchList.push({ id: doc.id, ...data });
                  workerPunches[data.workerId] = punchList;
                }
              });
            })
            .catch((err) => {
              console.error("in services > getWorkerTransportPunches, err===" + err);
            });
        }
        console.log("worker punches", workerPunches);
        resolve(workerPunches);
      } catch (error) {
        console.error("in services > getWorkerTransportPunches, Err===", error);
        reject(error);
      }
    })();
  });
};

/**
 * fn for fetching punch details for workerId, week.
 * @param {string} - workerId
 * @param {String} - startDate in yyyy-MM-dd format
 * @param {String} - endDate in yyyy-MM-dd format
 * @return: Promise - return the promise with punch details
 */
export const getWorkerPunchRecords = (workerId, startDate, endDate) => {
  console.log("limit endDate: ", endDate);
  console.log("limit startDate: ", startDate);
  console.log("workerId: ", workerId);
  console.log("services > getWorkerPunchRecords called...");
  return new Promise((resolve, reject) => {
    try {
      const documents = [];
      punchesRef()
        .where(WORKER_ID, EQUALS, workerId)
        // .orderBy(ACTIVITY_TS)
        .orderBy(IN_TS)
        .startAt(startDate)
        .endBefore(endDate)
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            if (doc.data().status !== "deleted") {
              documents.push({ id: doc.id, ...doc.data() });
            }
          });
          resolve(documents);
        })
        .catch((err) => {
          console.error("in services > getWorkerPunchRecords, err===" + err);
          reject(err);
        });
    } catch (error) {
      console.error("in services > getWorkerPunchRecords, Err===", error);
      reject(error);
    }
  });
};

/**
 * fn for fetching punch details for workerId, week.
 * @param {string} - workerId
 * @param {String} - startDate in yyyy-MM-dd format
 * @param {String} - endDate in yyyy-MM-dd format
 * @return: Promise - return the promise with punch details
 */
export const getNewWorkerPunchRecords = (workerId, startDate, endDate) => {
  console.log("endDate: ", endDate);
  console.log("startDate: ", startDate);
  console.log("workerId: ", workerId);
  console.log("services > getNewWorkerPunchRecords called...");
  return new Promise((resolve, reject) => {
    try {
      const documents = [];
      punchesRef()
        .where(WORKER_ID, EQUALS, workerId)
        // .orderBy(ACTIVITY_TS)
        .orderBy(IN_TS)
        .startAt(startDate)
        .endBefore(endDate)
        .get()
        .then((querySnapshot) => {
          if (querySnapshot.docs && querySnapshot.docs.length > 0) {
            querySnapshot.forEach((doc) => {
              if (doc.data().status !== "deleted") {
                documents.push({ id: doc.id, ...doc.data() });
              }
            });
            resolve(documents);
          } else {
            // user record not found in DB.
            resolve(documents[0]);
          }
        })
        .catch((err) => {
          console.error("in services > getNewWorkerPunchRecords, err===" + err);
          reject(err);
        });
    } catch (error) {
      console.error("in services > getNewWorkerPunchRecords, Err===", error);
      reject(error);
    }
  });
};

// current day meal punch status

/**
 * fn for fetching punch details for workerId, week.
 * @param {string} - workerId
 * @param {String} - startDate in yyyy-MM-dd format
 * @param {String} - endDate in yyyy-MM-dd format
 * @return: Promise - return the promise with punch details
 */
export const getCurrentDayMealPunches = (workerId, startTime, endTime) => {
  return new Promise((resolve, reject) => {
    try {
      const documents = [];
      let todayMealPunchAvailable = false;
      punchesRef()
        .where(WORKER_ID, EQUALS, workerId)
        .where("activityGroup", EQUALS, MEAL)
        .where(STATUS, IN, ["new", "edit", "approved", "exception"])
        .orderBy(IN_TS)
        .startAt(startTime)
        .endBefore(endTime)
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            todayMealPunchAvailable = true;
          });
          resolve(todayMealPunchAvailable);
        })
        .catch((err) => {
          console.error("in services > gettodayMealPunches, err===" + err);
          reject(err);
        });
    } catch (error) {
      console.error("in services > gettodayMealPunches, Err===", error);
      reject(error);
    }
  });
};

// for missed meal punch for a day

/**
 * fn for fetching punch details for workerId, week.
 * @param {string} - workerId
 * @param {String} - startDate in yyyy-MM-dd format
 * @param {String} - endDate in yyyy-MM-dd format
 * @return: Promise - return the promise with punch details
 */
export const saveMissingMealPunch = (data, lastPunch) => {
  return new Promise(async (resolve, reject) => {
    try {
      let { startTime, duration, exceptionDate, exceptionTime } = data;

      console.log("STARTTime", startTime);
      let timeStamp = new Date();

      if (exceptionDate && exceptionTime) {
        timeStamp = new Date(
          exceptionDate.getFullYear(),
          exceptionDate.getMonth(),
          exceptionDate.getDate(),
          exceptionTime.getHours(),
          exceptionTime.getMinutes(),
          exceptionTime.getSeconds(),
          exceptionTime.getMilliseconds()
        );
      }

      const workerId = lastPunch.workerId;
      const mealStartTime = moment(startTime).format(dateConfig.format7);
      console.log("Meal Start Time >>>>>>>>>>>>>>>>>>", mealStartTime);
      const mealStartTimeSec = moment(startTime).format(dateConfig.format4);
      const mealEndTime = moment(startTime)
        .add(duration, "minutes")
        .format(dateConfig.format7);
      const mealEndTimeSec = moment(startTime)
        .add(duration, "minutes")
        .format(dateConfig.format4);
      console.log("Meal End Time >>>>>>>>>>>>>>>>>>", mealEndTime);
      console.log("WORKER ID >>>>>>>>>>>>>>>>>>>", lastPunch.workerId);
      console.log("lastPunch >>>>>>>>>>>>>>>>>>>>", lastPunch);

      const missedClockOutExceptionName = MISSED_CLOCK_OUT;

      console.log("timeStamp::::A::;", timeStamp);

      const actionTS = new Date().toISOString();
      const outTS = timeStamp.toISOString();
      const outLocalTS = moment(timeStamp).format(dateConfig.format4);
      let recentClockIn = "";
      await getWorkerRecentClockIn(lastPunch.workerId).then(
        async (workerDoc) => {
          recentClockIn = workerDoc;
        }
      );
      let start;
      if (recentClockIn == undefined || recentClockIn == "") {
        start = moment(lastPunch.inLocalTS).format(dateConfig.format4);
      } else {
        start = moment(recentClockIn).format(dateConfig.format4);
      }
      const exceptionName = "";
      const isException = false;
      const punch = getPunch(
        lastPunch.activityGroup,
        lastPunch.activityName,
        lastPunch.buildingId,
        lastPunch.districtId,
        lastPunch.customerSite,
        lastPunch.exceptionName,
        lastPunch.isException,
        lastPunch.jobName,
        lastPunch.jobProjectInfo,
        lastPunch.status,
        lastPunch.version,
        lastPunch.workerId,
        actionTS,
        lastPunch.inTS,
        lastPunch.inLocalTS,
        outTS,
        outLocalTS,
        workerId,
        DEVICE_DETAILS,
        categoryPunch
      );

      const outTime = moment(outLocalTS).format(dateConfig.format7);
      if (mealStartTime < outTime && mealEndTime <= outTime) {
        const punchIn = moment(start).format(dateConfig.format6);
        const punchOut = moment(outLocalTS).format(dateConfig.format7);
        getNewWorkerPunchRecords(
          lastPunch.workerId,
          moment(punchIn).format(dateConfig.format4),
          moment(punchOut).format(dateConfig.format4)
        )
          .then((punches) => {
            if (punches != undefined && punches.length > 0) {
              let counter = 0;
              punches.forEach((punch) => {
                punch.inLocalTS = moment(punch.inLocalTS).format(
                  dateConfig.format7
                );
                const punch_inLocalTS = moment(punch.inLocalTS).format(
                  dateConfig.format4
                );
                punch.outLocalTS =
                  punch.outLocalTS != ""
                    ? moment(punch.outLocalTS).format(dateConfig.format7)
                    : "";
                const punch_outLocalTS =
                  punch.outLocalTS != ""
                    ? moment(punch.outLocalTS).format(dateConfig.format4)
                    : "";
                lastPunch.inLocalTS = moment(lastPunch.inLocalTS).format(
                  dateConfig.format7
                );
                if (counter == 0 && mealStartTime != "" && mealEndTime != "") {
                  const in_TS = new Date(mealStartTimeSec).toISOString();
                  const out_TS = new Date(mealEndTimeSec).toISOString();
                  const activityGroup = MEAL;
                  const activityName = CLOCK_OUT;
                  const mealPunch = getPunch(
                    activityGroup,
                    activityName,
                    punch.buildingId,
                    punch.districtId,
                    punch.customerSite,
                    exceptionName,
                    isException,
                    punch.jobName,
                    punch.jobProjectInfo,
                    punch.status,
                    punch.version,
                    punch.workerId,
                    actionTS,
                    in_TS,
                    mealStartTimeSec,
                    out_TS,
                    mealEndTimeSec,
                    workerId,
                    DEVICE_DETAILS,
                    categoryPunch,
                    punch.projectDetails
                  );
                  // if(lastPunch.projectDetails || lastPunch.projectDetails===SET_EMPTY){
                  //   if(lastPunch.projectDetails === SET_EMPTY){
                  //     mealPunch.projectDetails = SET_EMPTY;
                  //   }else mealPunch.projectDetails =lastPunch.projectDetails;

                  // }
                  console.log("If 7......");
                  let updateLastPunch = false;
                  if (
                    Math.floor(new Date(timeStamp).getTime() / 1000) -
                    new Date(timeStamp).getSeconds() ==
                    Math.floor(new Date(mealEndTime).getTime() / 1000) -
                    new Date(mealEndTime).getSeconds()
                  ) {
                    updateLastPunch = true;
                  }
                  createPunch(mealPunch, false)
                    .then(async (data) => {
                      if (updateLastPunch) {
                        await updateLastPunchId(
                          mealPunch.workerId,
                          mealPunch.activityGroup,
                          mealPunch.jobProjectInfo,
                          data,
                          false,
                          false
                        );
                      }
                      console.log("punch added 7", data);
                      resolve(true);
                    })
                    .catch((error) => {
                      console.log(error);
                      reject(new Error(error));
                    });
                }
                if (
                  (mealStartTime > punch.inLocalTS && punch.outLocalTS == "") ||
                  (punch.outLocalTS != "" &&
                    mealStartTime > punch.inLocalTS &&
                    mealStartTime < punch.outLocalTS)
                ) {
                  console.log("If 1......");
                  const outTS = new Date(mealStartTimeSec).toISOString();
                  if(!outTS){
                    outTS = new Date(moment(startTime).format(dateConfig.format4)).toISOString();
                  }
                  const activityName = CLOCK_OUT;
                  const firstPunch = getPunch(
                    punch.activityGroup,
                    activityName,
                    punch.buildingId,
                    punch.districtId,
                    punch.customerSite,
                    punch.exceptionName,
                    punch.isException,
                    punch.jobName,
                    punch.jobProjectInfo,
                    punch.status,
                    punch.version,
                    punch.workerId,
                    actionTS,
                    punch.inTS,
                    punch_inLocalTS,
                    outTS,
                    mealStartTimeSec,
                    workerId,
                    DEVICE_DETAILS,
                    categoryPunch,
                    punch.projectDetails
                  );
                  console.log("firstPunch:", firstPunch);

                  updatePunch(punch.id, firstPunch)
                    .then((data) => {
                      console.log("success on update punch1", data);
                    })
                    .catch((error) => {
                      console.log(error);
                      reject(new Error(error));
                    });
                }
                if (
                  mealEndTime > punch.inLocalTS &&
                  punch.outLocalTS != "" &&
                  mealEndTime < punch.outLocalTS &&
                  mealStartTime < punch.inLocalTS
                ) {
                  console.log("If 2......");
                  const inTS = new Date(mealEndTimeSec).toISOString();
                  const secondPunch = getPunch(
                    punch.activityGroup,
                    punch.activityName,
                    punch.buildingId,
                    punch.districtId,
                    punch.customerSite,
                    exceptionName,
                    isException,
                    punch.jobName,
                    punch.jobProjectInfo,
                    punch.status,
                    punch.version,
                    punch.workerId,
                    actionTS,
                    inTS,
                    mealEndTimeSec,
                    punch.outTS,
                    punch_outLocalTS,
                    workerId,
                    DEVICE_DETAILS,
                    categoryPunch,
                    punch.projectDetails
                  );
                  console.log("secondPunch:", secondPunch);
                  updatePunch(punch.id, secondPunch)
                    .then((data) => {
                      console.log("success on update punch2", data);
                    })
                    .catch((error) => {
                      console.log(error);
                      reject(new Error(error));
                    });
                }
                if (
                  punch.outLocalTS == "" &&
                  mealEndTime > punch.inLocalTS &&
                  mealStartTime < punch.inLocalTS
                ) {
                  console.log("If 3......");
                  const inTS = new Date(mealEndTimeSec).toISOString();
                  const outTS = new Date(timeStamp).toISOString();
                  const outLocalTS = moment(timeStamp).format(
                    dateConfig.format4
                  );
                  const activityName = CLOCK_OUT;
                  const thirdPunch = getPunch(
                    punch.activityGroup,
                    activityName,
                    punch.buildingId,
                    punch.districtId,
                    punch.customerSite,
                    exceptionDate && exceptionTime
                      ? missedClockOutExceptionName
                      : exceptionName,
                    exceptionDate && exceptionTime ? true : isException,
                    punch.jobName,
                    punch.jobProjectInfo,
                    punch.status,
                    punch.version,
                    punch.workerId,
                    actionTS,
                    inTS,
                    mealEndTimeSec,
                    outTS,
                    outLocalTS,
                    workerId,
                    DEVICE_DETAILS,
                    categoryPunch,
                    punch.projectDetails
                  );
                  updatePunch(punch.id, thirdPunch)
                    .then((data) => {
                      console.log("success on update punch3", data);
                    })
                    .catch((error) => {
                      console.log(error);
                      reject(new Error(error));
                    });
                }
                if (punch.outLocalTS == "" && mealEndTime < punch.inLocalTS) {
                  console.log("If 4......");
                  const outTS = new Date(timeStamp).toISOString();
                  const outLocalTS = moment(timeStamp).format(
                    dateConfig.format4
                  );
                  const activityName = CLOCK_OUT;
                  const forthPunch = getPunch(
                    punch.activityGroup,
                    activityName,
                    punch.buildingId,
                    punch.districtId,
                    punch.customerSite,
                    exceptionDate && exceptionTime
                      ? missedClockOutExceptionName
                      : exceptionName,
                    exceptionDate && exceptionTime ? true : isException,
                    punch.jobName,
                    punch.jobProjectInfo,
                    punch.status,
                    punch.version,
                    punch.workerId,
                    actionTS,
                    punch.inTS,
                    punch_inLocalTS,
                    outTS,
                    outLocalTS,
                    workerId,
                    DEVICE_DETAILS,
                    categoryPunch,
                    punch.projectDetails
                  );
                  console.log("forthPunch:", forthPunch);

                  updatePunch(punch.id, forthPunch)
                    .then((data) => {
                      console.log("success on update punch4", data);
                    })
                    .catch((error) => {
                      console.log(error);
                      reject(new Error(error));
                    });
                }
                if (
                  punch.outLocalTS != "" &&
                  mealStartTime > punch.inLocalTS &&
                  mealEndTime < punch.outLocalTS
                ) {
                  console.log("If 5......");
                  const inTS = new Date(mealEndTimeSec).toISOString();
                  const activityName = CLOCK_OUT;
                  const fifthPunch = getPunch(
                    punch.activityGroup,
                    activityName,
                    punch.buildingId,
                    punch.districtId,
                    punch.customerSite,
                    exceptionName,
                    isException,
                    punch.jobName,
                    punch.jobProjectInfo,
                    punch.status,
                    punch.version,
                    punch.workerId,
                    actionTS,
                    inTS,
                    mealEndTimeSec,
                    punch.outTS,
                    punch_outLocalTS,
                    workerId,
                    DEVICE_DETAILS,
                    categoryPunch,
                    punch.projectDetails
                  );
                  console.log("fifthPunch:", fifthPunch);
                  // if(lastPunch.projectDetails || lastPunch.projectDetails===SET_EMPTY){
                  //   if(lastPunch.projectDetails === SET_EMPTY){
                  //     fifthPunch.projectDetails = SET_EMPTY;
                  //   }else fifthPunch.projectDetails =lastPunch.projectDetails;

                  // }
                  createPunch(fifthPunch, false)
                    .then((data) => {
                      console.log("punch added 5", data);
                    })
                    .catch((error) => {
                      console.log(error);
                      reject(new Error(error));
                    });
                }
                console.log(
                  "new Date(timeStamp) === new Date(mealEndTime)",
                  new Date(timeStamp),
                  new Date(mealEndTime),
                  Math.floor(new Date(timeStamp).getTime() / 1000) -
                  new Date(timeStamp).getSeconds(),
                  Math.floor(new Date(mealEndTime).getTime() / 1000) -
                  new Date(mealEndTime).getSeconds(),
                  !(
                    Math.floor(new Date(timeStamp).getTime() / 1000) -
                    new Date(timeStamp).getSeconds() ==
                    Math.floor(new Date(mealEndTime).getTime() / 1000) -
                    new Date(mealEndTime).getSeconds()
                  )
                );
                //get time/1000 => removes milliseconds, subtract seconds => compare just minutes and seconds.
                if (
                  punch.outLocalTS == "" &&
                  mealStartTime > punch.inLocalTS &&
                  !(
                    Math.floor(new Date(timeStamp).getTime() / 1000) -
                    new Date(timeStamp).getSeconds() ==
                    Math.floor(new Date(mealEndTime).getTime() / 1000) -
                    new Date(mealEndTime).getSeconds()
                  )
                ) {
                  console.log("If 6......");
                  const inTS = new Date(mealEndTimeSec).toISOString();
                  const outTS = new Date(timeStamp).toISOString();
                  const outLocalTS = moment(timeStamp).format(
                    dateConfig.format4
                  );
                  const activityName = CLOCK_OUT;
                  const sixthPunch = getPunch(
                    punch.activityGroup,
                    activityName,
                    punch.buildingId,
                    punch.districtId,
                    punch.customerSite,
                    exceptionDate && exceptionTime
                      ? missedClockOutExceptionName
                      : exceptionName,
                    exceptionDate && exceptionTime ? true : isException,
                    punch.jobName,
                    punch.jobProjectInfo,
                    punch.status,
                    punch.version,
                    punch.workerId,
                    actionTS,
                    inTS,
                    mealEndTimeSec,
                    outTS,
                    outLocalTS,
                    workerId,
                    DEVICE_DETAILS,
                    categoryPunch,
                    punch.projectDetails
                  );
                  console.log("sixthPunch:", sixthPunch);
                  // if(lastPunch.projectDetails || lastPunch.projectDetails===SET_EMPTY){
                  //   if(lastPunch.projectDetails === SET_EMPTY){
                  //     sixthPunch.projectDetails = SET_EMPTY;
                  //   }else sixthPunch.projectDetails =lastPunch.projectDetails;
                  // }
                  addPunch(sixthPunch, false)
                    .then((data) => {
                      console.log("punch added 6", data);
                    })
                    .catch((error) => {
                      console.log(error);
                      reject(new Error(error));
                    });
                }
                if (
                  punch.outLocalTS !== "" &&
                  (mealStartTime < punch.inLocalTS ||
                    mealStartTime == punch.inLocalTS) &&
                  (punch.outLocalTS < mealEndTime ||
                    punch.outLocalTS == mealEndTime)
                ) {
                  console.log("Deleting Punch 8......");
                  const status = "deleted";
                  const eightPunch = getPunch(
                    punch.activityGroup,
                    punch.activityName,
                    punch.buildingId,
                    punch.districtId,
                    punch.customerSite,
                    punch.exceptionName,
                    punch.isException,
                    punch.jobName,
                    punch.jobProjectInfo,
                    status,
                    punch.version,
                    punch.workerId,
                    actionTS,
                    punch.inTS,
                    punch_inLocalTS,
                    punch.outTS,
                    punch_outLocalTS,
                    workerId,
                    DEVICE_DETAILS,
                    categoryPunch,
                    punch.projectDetails
                  );
                  console.log("EightPunch:", eightPunch);
                  updatePunch(punch.id, eightPunch)
                    .then((data) => {
                      console.log("success on update punch4", data);
                    })
                    .catch((error) => {
                      console.log(error);
                      reject(new Error(error));
                    });
                }
                // }
                counter++;
              });
            } else {
              const errMsg = "NO active punches found";
              reject(new Error(errMsg));
            }
          })
          .catch((error) => {
            console.log(error);
            reject(new Error(error));
          });
      }
      // else if (mealStartTime > outTime) {
      //   const error = "Meal Start Time cannot be greater than current Time";
      //   reject(new Error(error));
      // } else if (mealEndTime > outTime) {
      //   const error = "Meal end time cannot be greater than current time.";
      //   reject(new Error(error));
      // }
    } catch (error) {
      console.error("in services > getNewWorkerPunchRecords, Err===", error);
      reject(error);
    }
  });
};

/**
 * fn for fetching worker details for managerId
 * @param {String} - managerId
 * @param {String} - workerType optional
 * @return: Promise - return the promise with worker details
 */
export const getWorkersByMgr = (managerId, workerType) => {
  console.log("services > getWorkersByMgr called...");
  return new Promise((resolve, reject) => {
    try {
      if (managerId) {
        let query = workersRef().where(MANAGER_ID, EQUALS, managerId);
        if (workerType) {
          query = query.where(WORKER_TYPE, EQUALS, workerType);
        }
        query
          .where(IS_DELETED, NOT_EQUALS, true)
          .get()
          .then(async (querySnapshot) => {
            const workers = [];
            const workerIds = [];
            querySnapshot.forEach((doc) => {
              let data = doc.data();
              data.name = data.firstName + SPACE + data.lastName;
              workers.push(data);
              workerIds.push(doc.id);
            });
            //const pendingReviewCount = await getPendingReviews(workerIds);
            const data = {
              workers: workers,
              workerIds: workerIds,
            };
            //console.log('getWorkersByMgr -> ', data);
            resolve(data);
          })
          .catch((err) => {
            console.error("in services > getWorkersByMgr, err===" + err);
            reject(err);
          });
      } else {
        console.log("in services > getWorkersByMgr ManagerID is undefined");
        resolve(false);
      }
    } catch (error) {
      console.error("in services > getWorkersByMgr, Err===", error);
      reject(error);
    }
  });
};

/**
 * fn for fetching manager email details of given country
 * @return: Promise - return the promise with email details
 */
export const getManagerEmailDetails = (country) => {
  console.log("services > getManagerEmailDetails called...", country);
  return new Promise((resolve, reject) => {
    try {
      const managers = [];
      const managersCostCenterData = {};
      let managerQuery = workersRef();
      if (country && country !== "") {
        managerQuery = managerQuery.where(COUNTRY, EQUALS, country);
      }
      managerQuery
        // .where(IS_MANAGER, EQUALS, true)
        .where(IS_APPROVER, EQUALS, true)
        .where(IS_DELETED, NOT_EQUALS, true)
        .where(IS_ACTIVE_WORKER, EQUALS, true)
        .orderBy(IS_DELETED)
        .orderBy(FIRST_NAME)
        .orderBy(LAST_NAME)
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            const data = doc.data();

            //remove all managers for whom country is test country

            // if (data && data.email) {
            if (data.country !== "testCountry") {
              const manager = {
                managerFirstName: data.firstName,
                managerLastName: data.lastName,
                managerId: data.workerId,
                managerEmail: data.email,
                managerCountry: data.country,
              };
              managers.push(manager);
              if(data.workerId){
              const managerData = {
                managerFirstName: data.firstName,
                managerLastName: data.lastName,
                managerId: data.workerId,
                managerEmail: data.email,
                managerCountry: data.country,
                costCenter : data.costCenter ? data.costCenter : '',
                costCenterId : data.costCenterId ? data.costCenterId : '',
                product : data.product ? data.product : '',
                productId : data.productId ? data.productId : '',
                function : data.function ? data.function : '',
                functionId : data.functionId ? data.functionId : '',
              }
              managersCostCenterData[data.workerId] = {...managerData};
            }
            }
          });
          // console.log('Manager Emails',managers);
          resolve({managers,managersCostCenterData});
        })
        .catch((err) => {
          console.error("in services > getManagerEmailDetails, err===" + err);
          reject(err);
        });
    } catch (error) {
      console.error("in services > getManagerEmailDetails, Err===", error);
      reject(error);
    }
  });
};

/**
 * fn for reassigning workers to new manager
 * @param {String} - managerId
 * @param {Object} - newManager
 * @return: Promise - return the promise with worker details
 */
export const reassignReportees = (managerId, newManager) => {
  console.log("services > reassignReportees called...");
  return new Promise((resolve, reject) => {
    try {
      if (managerId) {
        let query = workersRef().where(MANAGER_ID, EQUALS, managerId);
        query
          .where(IS_DELETED, NOT_EQUALS, true)
          .get()
          .then(async (querySnapshot) => {
            querySnapshot.forEach((doc) => {
              let newWorker = doc.data();
              let version;
              if (doc.data().version) {
                version = doc.data().version + 1;
              } else {
                version = 2;
              }
              newWorker = { ...doc.data(), ...newManager };
              newWorker.version = version;

              setWorkerHistory(doc.data(), doc.id);
              updateWorker(newWorker, doc.id);
            });
            console.log(
              "reassignReportees > No. of workers updated = ",
              querySnapshot.size
            );
            resolve(true);
          })
          .catch((err) => {
            console.error("in services > reassignReportees, err===" + err);
            reject(err);
          });
      } else {
        console.log("in services > reassignReportees ManagerID is undefined");
        resolve(false);
      }
    } catch (error) {
      console.error("in services > reassignReportees, Err===", error);
      reject(error);
    }
  });
};

/**
 * fn for fetching pending punch reviews for workerIds
 * @param {Array} - workerIds
 * @return: Promise - return the promise with punch details
 */
export const getPendingReviews = (workerIds) => {
  console.log("services > getPendingReviews called...");
  // eslint-disable-next-line no-async-promise-executor
  return new Promise(async (resolve, reject) => {
    try {
      let pendingReviewCount = 0;
      for (let i = 0; i < workerIds.length; i += ARRAY_LIMIT) {
        const workerIdList = workerIds.slice(i, i + ARRAY_LIMIT);
        await getPendingPunchCount(workerIdList).then((val) => {
          pendingReviewCount = pendingReviewCount + val;
        });
      }
      resolve(pendingReviewCount);
    } catch (error) {
      console.error("in services > getPendingReviews, Err===", error);
      reject(error);
    }
  });
};

/**
 * fn for fetching pending punch count for workerIds
 * @param {Array} - workerIds
 * @return: Promise - return the promise with punch details
 */
export const getPendingPunchCount = (workerIds) => {
  console.log("services > getPendingPunchCount called...");
  return new Promise((resolve, reject) => {
    try {
      punchesRef()
        .where(WORKER_ID, IN, workerIds)
        .where(STATUS, EQUALS, NEW)
        .get()
        .then((querySnapshot) => {
          const count = querySnapshot.size;
          resolve(count);
        })
        .catch((err) => {
          console.error("in services > getPendingPunchCount, err===" + err);
          reject(err);
        });
    } catch (error) {
      console.error("in services > getPendingPunchCount, Err===", error);
      reject(error);
    }
  });
};

/**
 * fn for fetching worker roles for a worker
 * @param {string} - workerId
 * @return: Promise - return the promise with worker role details
 *                  - resolve with null if worker roles does not exists
 */
export const getWorkerRoles = async (workerId) => {
  console.log("services > getWorkerRoles =====", workerId);
  return new Promise((resolve, reject) => {
    try {
      if (workerId) {
        const workerRoles = {};
        const selectedRegion = {};
        return workersRef()
          .doc(workerId)
          .collection("workerRoles")
          .get()
          .then((querySnapshot) => {
            if (querySnapshot.docs && querySnapshot.docs.length > 0) {
              querySnapshot.forEach((doc) => {
                const data = doc.data();
                const role = {
                  id: doc.id,
                  activityFamilyId: data.activityFamilyId,
                  region: data.region,
                  userId: data.userId,
                  isActive: data.isActive ? data.isActive : false,
                  role:data.role,
                };
                if (!workerRoles[data.activityFamilyId]) {
                  workerRoles[data.activityFamilyId] = {};
                }
                if (data.region) {
                  workerRoles[data.activityFamilyId][data.region] = role;
                  if (!selectedRegion[data.activityFamilyId]) {
                    selectedRegion[data.activityFamilyId] = [];
                  }
                  if(data.isActive)
                  selectedRegion[data.activityFamilyId].push(data.region);
                }
              });
              workerRoles.selectedRegion = selectedRegion;
              resolve(workerRoles);
            } else {
              resolve(null);
            }
          })
          .catch((err) => {
            console.error("in services > getDetailsByEmail, err===" + err);
            reject(err);
          });
      }
    } catch (error) {
      console.error(
        "in services > getUserDetails: Err in firestore query...",
        error
      );
      reject(error);
    }
  });
};

/**
 * fn for fetching worker roles for a worker
 * @param {string} - workerId
 * @return: Promise - return the promise with worker role details
 *                  - resolve with null if worker roles does not exists
 */
export const getAllWorkerRoles = async (workerId) => {
  console.log("services > getWorkerRoles =====", workerId);
  return new Promise((resolve, reject) => {
    try {
      if (workerId) {
        const workerRoles = {
          imWarehouse : {}
        };
        const enabledRoles = {};
        const warehouseFamily = ['SKP', 'AT', 'SB'];
        return workersRef()
          .doc(workerId)
          .collection("workerRoles")
          .get()
          .then((querySnapshot) => {
            if (querySnapshot.docs && querySnapshot.docs.length > 0) {
              querySnapshot.forEach((doc) => {
                const data = doc.data();
                console.log("getAllWorkerRoles", data.activityFamilyId, warehouseFamily, warehouseFamily.includes(data.activityFamilyId));
                if(data.activityFamilyId){
                  if(warehouseFamily.includes(data.activityFamilyId)){

                    const role = {
                      id: doc.id,
                      activityFamilyId: data.activityFamilyId,
                      region: data.region,
                      userId: data.userId,
                      isActive: data.isActive ? data.isActive : false
                    };
                    if(data.role){
                      role.role = data.role;
                    }
                    if (!workerRoles.imWarehouse[data.activityFamilyId]) {
                      workerRoles.imWarehouse[data.activityFamilyId] = {};
                    }
                    workerRoles.imWarehouse[data.activityFamilyId][data.region] = role;
                    if(data.isActive){
                      if(!workerRoles.imWarehouse.selectedRegions){
                        workerRoles.imWarehouse.selectedRegions = {};
                      }
                      if(!workerRoles.imWarehouse.selectedRegions[data.activityFamilyId]){
                        workerRoles.imWarehouse.selectedRegions[data.activityFamilyId] = [];
                      }
                      workerRoles.imWarehouse.selectedRegions[data.activityFamilyId].push(data.region)
                      enabledRoles['imWarehouse'] = true;
                    }
                  }else{
                  workerRoles[data.activityFamilyId] = {...data, docId: doc.id};
                  enabledRoles[data.activityFamilyId] = data.isActive ? data.isActive : false;
                  }
                }else if(doc.id === "timeRole"){
                  workerRoles["timeRole"] = {...data, docId: doc.id};
                  enabledRoles["timeRole"] = data.isActive ? data.isActive : false;
                }else if(doc.id === "gorpa"){
                  workerRoles["gorpa"] = {...data, docId: doc.id};
                  enabledRoles["gorpa"] = data.isActive ? data.isActive : false;
                }
              });
              resolve({workerRoles, enabledRoles});
            } else {
              resolve(null);
            }
          })
          .catch((err) => {
            console.error("in services > getDetailsByEmail, err===" + err);
            reject(err);
          });
      }
    } catch (error) {
      console.error(
        "in services > getUserDetails: Err in firestore query...",
        error
      );
      reject(error);
    }
  });
};

/**
 * fn for adding worker roles details to the FS sub collection
 * @param {string} - workerId
 * @param {array} - workerRoles
 * @param {string} - actionByUserId
 * @return: Promise - return the promise with update worker role doc ids
 *                  - resolve with empty array if worker roles does not exists
 */
export const addWorkerRoles = async (workerId, workerRoles, actionByUserId) => {
  console.log("services > getWorkerRoles =====", workerId);
  return new Promise((resolve, reject) => {
    try {
      const updatedWorkerRoles = [];
      if (workerRoles.length > 0) {
        workerRoles.forEach((workerRole) => {
          delete workerRole.error;
          workerRole.userId = workerRole.userId
            ? workerRole.userId.toUpperCase()
            : workerRole.userId;
          workerRole.actionBy = actionByUserId;
          workerRole.actionTS = new Date().toISOString();
          if (workerRole.id) {
            workerRole.actionType = EDIT;
            const workerRoleId = workerRole.id;
            delete workerRole.id;
            const workerRoleDoc = workersRef()
              .doc(workerId)
              .collection(WORKER_ROLES)
              .doc(workerRoleId);
            let isUpdated = false;
            workerRoleDoc
              .get()
              .then(async (doc) => {
                if (
                  doc.data().userId != workerRole.userId ||
                  doc.data().isActive != workerRole.isActive || 
                  doc.data().role != workerRole.role 
                ) {
                  isUpdated = true;
                  await saveWorkerRoleHistory(doc.data(), workerId);
                }
                return;
              })
              .then(() => {
                if (isUpdated) {
                  workerRoleDoc
                    .set(workerRole, { merge: true })
                    .then(() => {
                      updatedWorkerRoles.push(workerRoleId);
                    })
                    .catch((err) => {
                      console.error("in services > addWorkerRoles, err::", err);
                      reject(err);
                    });
                }
              })
              .catch((err) => {
                console.error(
                  "in services > updatingworkerRoleHistory, err::",
                  err
                );
                reject(err);
              });
          } else {
            workerRole.actionType = ADD;
            workersRef()
              .doc(workerId)
              .collection(WORKER_ROLES)
              .add(workerRole)
              .then((docRef) => {
                updatedWorkerRoles.push(docRef.id);
              })
              .catch((err) => {
                console.error("in services > addWorkerRoles, err::", err);
                reject(err);
              });
          }
        });
        console.log("in services > updatedWorkerRoles");
      }
      resolve(updatedWorkerRoles);
    } catch (error) {
      console.error(
        "in services > addWorkerRoles: Err in firestore query...",
        error
      );
      reject(error);
    }
  });
};

/**
 * fn for adding worker roles details to the FS sub collection
 * @param {string} - workerId
 * @param {object} - updatedDocs
 * @param {string} - actionByUserId
 * @return: Promise - return the promise with update worker role doc ids
 *                  - resolve with empty array if worker roles does not exists
 */
export const updateIMWarehouseRoles = async (workerId, updatedDocs, actionByUserId, activityFamilyIds) => {
  try {
    console.log("services > updateIMWarehouseRoles =====", workerId);
    // Validate required parameters
    if (!workerId || !actionByUserId || !activityFamilyIds || !Array.isArray(activityFamilyIds) || Object.keys(updatedDocs).length === 0) {
      throw new Error("Missing details to update (workerId, actionByUserId, or updatedDocs).");
    }

    const workerRolesRef = workersRef().doc(workerId).collection(WORKER_ROLES);
    // Step 1: Query the documents for the activityFamilyIds in a single query
    const querySnapshot = await workerRolesRef
      .where('activityFamilyId', 'in', activityFamilyIds)
      .get();
    // Create a batch to perform multiple Firestore operations
    const batch = db.batch();
    // Step 2: If querySnapshot is not empty, process existing documents
    if (!querySnapshot.empty) {
      querySnapshot.forEach(doc => {
        const docData = doc.data();
        const activityFamilyId = docData?.activityFamilyId;
        const region = docData?.region;
        // Null or missing checks for required fields
        if (!activityFamilyId || !region) {
          console.warn(`Skipping document due to missing 'activityFamilyId' or 'region'.`);
          return; // Skip this document if data is invalid
        }
        // Check if updatedDocs has data for this activityFamilyId and region
        if (updatedDocs[activityFamilyId] && updatedDocs[activityFamilyId][region]) {
          const updatedData = {
            ...updatedDocs[activityFamilyId][region],
            actionBy: actionByUserId,
            actionTS: new Date().toISOString(),
            actionType: 'EDIT',
          };
          // Remove the 'id' field before updating
          delete updatedData.id;
          // Update the document if necessary
          batch.update(doc.ref, updatedData);
          console.log(`Updated document for ${activityFamilyId} in region ${region}`);
        }
      });
    }
  
    // Step 3: Handle documents that do not exist and need to be created
    for (const activityFamilyId in updatedDocs) {
      if (!updatedDocs[activityFamilyId]) continue;
      const regions = updatedDocs[activityFamilyId];
      for (const region in regions) {
        if (!regions[region]) continue;
        // Check if the document already exists in the querySnapshot
        const existingDoc = querySnapshot.docs.find(doc => 
          doc.data().activityFamilyId === activityFamilyId && doc.data().region === region
        );
        if (!existingDoc) {
          // Document doesn't exist, so create it
          const newDocRef = workerRolesRef.doc(); // Generate a new document reference
          // Prepare the data for the new document
          const newData = {
            actionBy: actionByUserId,
            actionTS: new Date().toISOString(),
            actionType: 'NEW',
            activityFamilyId,
            region,
            ...regions[region], // Spread the updated data
          };
          // Remove the 'id' field before setting the new document
          delete newData.id;
          // Create the document
          batch.set(newDocRef, newData);
          console.log(`Added new document for ${activityFamilyId} in region ${region}`);
        }
      }
    }
    // Step 4: Commit the batch write
    await batch.commit();
    console.log("Batch write completed.");
    return { status: true };
  } catch (error) {
    console.error("Error in services > updateIMWarehouseRoles:", error);
    return { status: false, message: error.message || 'An unknown error occurred' };
  }
};



/**
 * fn created to take backup of WorkersRoles collection in workerRolesHistory collection
 * @param {Object} - object containing all punch details
 * @return: Promise - return the promise with new firestore document ref
 */
export const saveWorkerRoleHistory = async (worker, workerId) => {
  console.log("services > saveWorkerRoleHistory called...");
  return new Promise((resolve, reject) => {
    try {
      return workersRef()
        .doc(workerId)
        .collection(WORKER_ROLES_HISTORY)
        .add(worker)
        .then((docRef) => {
          resolve(docRef);
        })
        .catch((err) => {
          console.error("in services > saveWorkerRoleHistory, err::", err);
          reject(err);
        });
    } catch (error) {
      console.error("in services > saveWorkerRoleHistory, Err::", error);
      reject(error);
    }
  });
};

export const getPreviousPunches = (workerId) => {
  console.log("workerId: ", workerId);
  console.log("services > getPreviousPunches called...");

  return new Promise((resolve, reject) => {
    try {
      const documents = [];
      punchesRef()
        .where(WORKER_ID, EQUALS, workerId)
        .orderBy(IN_TS, "desc")
        .limit(10)
        .get()
        .then((querySnapshot) => {
          if (querySnapshot.docs && querySnapshot.docs.length > 0) {
            querySnapshot.forEach((doc) => {
              documents.push({ id: doc.id, ...doc.data() });
            });
            resolve(documents);
          } else {
            // user record not found in DB.
            resolve(documents[0]);
          }
        })
        .catch((err) => {
          console.error("in services > getPreviousPunches, err===" + err);

          reject(err);
        });
    } catch (error) {
      console.error("in services > getPreviousPunches, Err===", error);

      reject(error);
    }
  });
};

export const getWeekHoursDetails = (workerId, weekNumber) => {
  console.log("workerId: ", workerId, "weekNumber: ", weekNumber);
  console.log("services > getWeekHoursDetails called...");

  const documentName = weekNumber + "-" + workerId;

  return new Promise((resolve, reject) => {
    try {
      const document = [];
      timesheetsRef()
        .doc(documentName)
        .get()
        .then((querySnapshot) => {
          if (querySnapshot.data()) {
            const data = querySnapshot.data().dayTotals;
            for (let i in data) {
              document.push({ day: i, hours: data[i].activityHours });
            }
          } else {
            document.push(
              { day: "Sunday", hours: 0 },
              { day: "Monday", hours: 0 },
              { day: "Tuesday", hours: 0 },
              { day: "Wednesday", hours: 0 },
              { day: "Thursday", hours: 0 },
              { day: "Friday", hours: 0 },
              { day: "Saturday", hours: 0 }
            );
          }

          resolve(document);
        })
        .catch((err) => {
          console.error("in services > getWeekHoursDetails, err===" + err);

          reject(err);
        });
    } catch (error) {
      console.error("in services > getPreviousPunches, Err===", error);

      reject(error);
    }
  });
};

/**
 * fn for getting Project Details for a particular country
 * @param {String} - Country
 * @return: Promise - return the promise with new firestore document ref
 */
export const getProjectDetails = async (userCountry) => {
  console.log("services > worker > getProjectDetails called...");
  return new Promise((res, rej) => {
    try {
      const documents = [];
      return collectionGroup(IMT_ACTIVITY_GROUP)
        .where(COUNTRY, EQUALS, userCountry)
        .get()
        .then((snapshot) => {
          const projectDetails = snapshot.docs
            .map((doc) => ({
              id: doc.id,
              activityGroup: doc.data().activityGroup,
              name: doc.data().name,
              isActive: doc.data().isActive,
              jobRoles: doc.data().jobRoles,
              isJobRoleRestricted: doc.data().isJobRoleRestricted,
              restrictedDistricts: doc.data().restrictedDistricts,
              isDistrictRestricted: doc.data().isDistrictRestricted,
            }))
            .filter((e) => e.isActive && !e.isDeleted);
          const obj = {};
          let keys = [];
          for (let item of projectDetails) {
            const { id, activityGroup } = item;
            const actGroup = activityGroup;
            if (keys == null) {
              keys.push(actGroup);
            } else if (keys.indexOf(actGroup) == -1) {
              keys.push(actGroup);
            }
          }
          for (let key of keys) {
            obj[key] = projectDetails.filter((e) => {
              return e.activityGroup == key;
            });
          }
          // console.log(keys)
          res(obj);
          //console.log(obj);
        })
        .catch((err) => {
          console.error(
            "in services > worker > getProjectDetails, err===" + err
          );
          rej(err);
        });
    } catch (error) {
      console.error("in services > worker > getProjectDetails, err===" + error);
      rej(error);
    }
  });
};
/**
 * fn get activityGroup details based on country name.
 * @param {String} - country name as per the database
 * @return: Promise - return the promise with details.
 */

export const getProjectsByCountry = (country) => {
  console.log("services > getProjectsByCountry called... country=", country);
  return new Promise((resolve, reject) => {
    try {
      if (country) {
        collectionGroup(IMT_ACTIVITY_GROUP)
          .where(COUNTRY, EQUALS, country)
          .get()
          .then(function (querySnapshot) {
            console.log("SS:: getProjectsByCountry data===", querySnapshot);
            let projects = [];
            querySnapshot.forEach((doc) => {
              if (doc.data() && !doc.data().isDeleted) {
                projects.push({ id: doc.id, ...doc.data() });
              }
            });
            console.log("SS:: getProjectsByCountry projects===", projects);
            resolve(projects);
          })
          .catch((err) => {
            console.error("in services > getProjectsByCountry, err===" + err);
            reject(err);
          });
      } else {
        console.log(
          "in services > getProjectsByCountry ManagerID is undefined"
        );
        resolve(false);
      }
    } catch (error) {
      console.error("in services > getProjectsByCountry, Err===", error);
      reject(error);
    }
  });
};

/**
 * fn get country id based on country name.
 * @param {String} - country name as per the database
 * @return: Promise - return the promise with new countryId.
 */
export const getCountryId = (country) => {
  console.log("services > getCountryId: called... country=", country);
  return new Promise((resolve, reject) => {
    return countriesRef()
      .where(COUNTRY_NAME, EQUALS, country)
      .limit(1)
      .get()
      .then((querySnapshot) => {
        if (querySnapshot.docs && querySnapshot.docs.length > 0) {
          console.log(`Country Id for ${country}=`, querySnapshot.docs[0].id);
          resolve(querySnapshot.docs[0].id);
        } else {
          console.log("services > getCountryId: Country not found!");
          reject("Country not found!");
        }
      })
      .catch((err) => {
        console.error("services > getCountryId, err===" + err);
        reject("Err in services > getCountryId::", err);
      });
  });
};

/**
 * fn to add new Project of a country
 * @param {Object} - activityGroup
 * @return: Promise - return the promise with created project doc
 */
export const addNewActivityGroup = (activityGroup) => {
  // console.log(
  //   "services > addNewActivityGroup called... activityGroup=",
  //   activityGroup
  // );
  return new Promise((resolve, reject) => {
    try {
      if (activityGroup && activityGroup.country) {
        getCountryId(activityGroup.country)
          .then((countryId) => {
            console.log("SS:: countryId===", countryId);
            return (
              collectionRef(CL_COUNTRIES)
                .doc(countryId)
                // .collection(CL_SUB_ACTIVITY_GROUP)
                .collection(IMT_ACTIVITY_GROUP)
                .add(activityGroup)
            );
          })
          .then((docRef) => {
            console.log("SS:: docRef===", docRef);
            activityGroup.id = docRef.id;
            resolve(activityGroup);
          })
          .catch((err) => {
            console.error("in services > addNewActivityGroup, err===", err);
            reject(err);
          });
      } else {
        console.log("in services > addNewActivityGroup country is undefined");
        reject("Country is undefined!");
      }
    } catch (error) {
      console.error("in services > addNewActivityGroup, Err===", error);
      reject(error);
    }
  });
};

export const editActivityGroup = (activityGroupId, activityGroup) => {
  console.log("services > editActivityGroup called...");
  return new Promise(async (resolve, reject) => {
    try {
      getCountryId(activityGroup.country)
        .then((countryId) => {
          console.log("SS:: countryId===", countryId);
          let data = collectionRef(CL_COUNTRIES)
            .doc(countryId)
            .collection(IMT_ACTIVITY_GROUP)
            .doc(activityGroupId);

          data
            .get()
            .then((docRef) => {
              setActivityGroupHistory(data, docRef.data());
              data.update(activityGroup);
            })
            .catch((err) => {
              console.error("processing setActivityGroupHistory err===", err);
              reject(err);
            });
        })
        .then((docRef) => {
          resolve(true);
        })
        .catch((err) => {
          console.error("in services > editActivityGroup, err===", err);
          reject(err);
        });
    } catch (error) {
      console.error("in services > editActivityGroup, Err===", error);
      reject(error);
    }
  });
};

// deleting
export const editActivityGroupDelete = (activityGroups, country) => {
  console.log("services > editActivityGroupDelete called...");
  return new Promise(async (resolve, reject) => {
    try {
      getCountryId(country)
        .then(async (countryId) => {
          console.log("SS:: countryId===", countryId);

          let activityGroupCollection = collectionRef(CL_COUNTRIES)
          .doc(countryId)
          .collection(IMT_ACTIVITY_GROUP)
        
          await activityGroups.forEach(activityGroup => {
          
           let data= activityGroupCollection.doc(activityGroup.id);
           data.get()
               .then((docRef) => {
                setActivityGroupHistory(data, docRef.data());
                delete activityGroup.id;
                data.update(activityGroup);
              })
              .catch((err) => {
                console.error("processing setActivityGroupHistory err===", err);
                reject(err);
              });
          })
        })
        .then((docRef) => {
          resolve(true);
        })
        .catch((err) => {
          console.error("in services > editActivityGroup, err===", err);
          reject(err);
        });
    } catch (error) {
      console.error("in services > editActivityGroup, Err===", error);
      reject(error);
    }
  });
};

export const setActivityGroupHistory = (historyData, activityGroup) => {
  console.log("services > setActivityGroupHistory called...");
  return new Promise((resolve, reject) => {
    try {
      historyData
        .collection(IMT_ACTIVITY_GROUPHISTORY)
        .add(activityGroup)
        .then((docRef) => {
          resolve(true);
        })
        .catch((err) => {
          console.error("in services > setActivityGroupHistory, err===", err);
          reject(err);
        });
    } catch (error) {
      console.error("in services > setActivityGroupHistory, Err===", error);
      reject(error);
    }
  });
};

//testing for delegate
export const getParentManager = (workerId) => {
  console.log("services -> delegateManager -> getParentManager called....");
  return new Promise((resolve, reject) => {
    try {
      const managers = [];
      let managerQuery = workersRef();
      // if (country && country !== "") {
      //   managerQuery = managerQuery.where(COUNTRY, EQUALS, country);
      // }
      managerQuery
        .where("approvingManager", "array-contains", workerId)
        //.where(IS_APPROVER, EQUALS, true)
        .where(IS_DELETED, NOT_EQUALS, true)
        .where(IS_ACTIVE_WORKER, EQUALS, true)
        //.orderBy(IS_DELETED)
        //.orderBy(FIRST_NAME)
        //.orderBy(LAST_NAME)
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            const data = doc.data();
            // if (data && data.email) {
            if (data) {
              const manager = {
                managerFirstName: data.managerFirstName,
                managerLastName: data.managerLastName,
                managerId: data.managerId,
                managerEmail: data.managerEmail,
                workerName: data.firstName + " " + data.lastName,
              };
              managers.push(manager);
            }
          });
          console.log("Manager Emails", managers);
          resolve(managers);
        })
        .catch((err) => {
          console.error("in services > getManagerEmailDetails, err===" + err);
          reject(err);
        });
    } catch (error) {
      console.error("in services > getManagerEmailDetails, Err===", error);
      reject(error);
    }
  });
};

export const deepEqual = (object1, object2) => {
  const keys1 = Object.keys(object1);
  const keys2 = Object.keys(object2);

  if (keys1.length !== keys2.length) {
    return false;
  }

  for (const key of keys1) {
    const val1 = object1[key];
    const val2 = object2[key];
    const areObjects = isObject(val1) && isObject(val2);
    if (
      (areObjects && !deepEqual(val1, val2)) ||
      (!areObjects && val1 !== val2)
    ) {
      return false;
    }
  }

  return true;
};

const isObject = (object) => {
  return object != null && typeof object === "object";
};

/**
 * fn for retrieving recent clockIn punch details.
 * @param {workerId} - worker record doc id
 * @return: Promise - return the promise with punch details
 */
export const getWorkerRecentClockIn = (workerId) => {
  console.log("services > getWorkerRecentClockIn called...");
  return new Promise((resolve, reject) => {
    try {
      let clockIn;
      workersRef()
        .doc(workerId)
        .get()
        .then(async (snapshot) => {
          if (snapshot.exists) {
            clockIn = snapshot.data().clockIn;
          }
          resolve(clockIn);
        })
        .catch((err) => {
          console.error("in services > getWorkerRecentClockIn, err===" + err);
          reject(err);
        });
    } catch (error) {
      console.error("in services > getWorkerRecentClockIn, Err===", error);
      reject(error);
    }
  });
};

//Service function to fetch lang Translations based on updates.
export const onLangTranslationUpdates = (callback) => {
  console.log("services>>>>onLangTranslationUpdates Called>>>");
  let translations = new Object();
  collectionRef("translations").onSnapshot(async (snapshot) => {
    // console.log("translations" + snapshot.size + snapshot);
    if (snapshot && snapshot.docChanges) {
      console.log("exists");
      snapshot.forEach((doc) => {
        if (doc.id && doc.id.endsWith("web"))
          translations[doc.id.split("-")[0]] = doc.data().val;
      });
      await callback(translations);
    }
    console.log(Object.keys(translations).length);
  });
};

export const getWeekNumber = (dt) => {
  dt = moment(dt).day() < 1 ? moment(dt).add(1, "d").format() : dt;
  let weekNo = moment(dt).isoWeek();
  if (weekNo && weekNo != NaN) {
    const weekNumberLen = weekNo.toString().length;
    if (weekNumberLen === 1) {
      weekNo = "0" + weekNo.toString();
    }
  }
  return moment(dt).isoWeekYear() + "" + weekNo;
};

export const getWeekStartDate = (d) =>{
  return moment().startOf('week').format("YYYY-MM-DD");
}

/**
 * Calcuates the time duration between inLocalTS and outLocalTS
 * @param {inLocalTS} inLocalTS
 * @param {outLocalTS} outLocalTS
 * @return {hours} hours
 */
function getDurationInHours(inLocalTS, outLocalTS) {
  let hours = 0;
  try {
    if (
      inLocalTS &&
      inLocalTS !== "" &&
      inLocalTS !== "null" &&
      outLocalTS &&
      outLocalTS !== "" &&
      outLocalTS !== "null"
    ) {
      const end = moment(outLocalTS && outLocalTS.substr(0, 16));
      const start = moment(inLocalTS && inLocalTS.substr(0, 16));
      if (start.isValid() && end.isValid()) {
        const diff = moment.duration(end.diff(start));
        hours = diff.asHours();
      }
    }
  } catch (error) {
    console.error("Error in duration calculation: ", error);
  }
  return hours.toFixed(2);
}

export const resetWorkerPin = (workerId, newPin) => {
  return new Promise((resolve, reject) => {
    try {
      workersRef()
        .doc(workerId)
        .update({ pin: newPin })
        .then(() => {
          resolve(true);
        });
    } catch (error) {
      console.log("RESET PIN error: ", error);
      reject(error);
    }
  });
};

/**
 * fn for fetching weekly activity total hours from timesheet doc.
 * @param {string} - workerId
 * @return: Promise - return the promise with punch details
 */
export const getTimesheetActHours = (workerId) => {
  console.log("services > getTimesheetActHours called...");
  return new Promise((resolve, reject) => {
    try {
      const weekNumber = getWeekNumber(new Date());
      const id = `${weekNumber}-${workerId}`;
      let activityHours = 0;
      collectionRef("timesheets")
        .doc(id)
        .get()
        .then((doc) => {
          console.log("timesheet details===\n", doc.data());
          const data = doc.data();
          if (
            doc.exists &&
            data.status != "deleted" &&
            data.weekTotalHours.activityHours > 0
          ) {
            activityHours = data.weekTotalHours.activityHours;
          }
          resolve(activityHours);
        })
        .catch((err) => {
          console.error("getTimesheetActHours err::" + err);
          reject(err);
        });
    } catch (error) {
      console.error("getTimesheetActHours Err::", error);
      reject(error);
    }
  });
};

/**
 * fn for fetching district and bulding map from locations collection where and wms = SKP
 */
export const getDistrictBuildingMapForIMWarehouse = (userCountry) => {
  console.log("services > getDistrictBuildingMapForIMWarehouse2 called...");
  return new Promise((resolve, reject) => {
    if (userCountry) {
      try {
        collectionGroup(BUILDINGS_SUBCOLLECTION)
          .where(COUNTRY, EQUALS, userCountry)
          .where("wms", "==", "SKP")
          .get()
          .then((querySnapshot) => {
            const districtBuildingMap = {};
            querySnapshot.docs.map((doc) => {
              const district = doc.data().districtName;
              const activityEnabled = doc.data().activityEnabled;
              if (activityEnabled) {
                if (districtBuildingMap[district] !== undefined) {
                  districtBuildingMap[district].push(doc.id);
                } else {
                  districtBuildingMap[district] = [];
                  districtBuildingMap[district].push(doc.id);
                }
              }
            });

            resolve(districtBuildingMap);
          })
          .catch((error) => {
            console.error("getDistrictBuildingMapForIMWarehouse2 er:: ", error);
            reject(error);
          });
      } catch (error) {
        console.error("getDistrictBuildingMapForIMWarehouse2 er:: ", error);
        reject(error);
      }
    } else {
      resolve({});
    }
  });
};
// deleting
export const deleteTripPunch = (selectedPunches) => {
  console.log("services > deleteTripPunch called...");
  return new Promise(async (resolve, reject) => {
    try {
         await selectedPunches.forEach(punch => {
                  const punchInLocalTs = punch.startTripLocalTS;
                  const punchOutLocalTs = punch.endTripLocalTS;
                  let duration = 0.0;
                  if (punchOutLocalTs) {
                    let hours = getDurationInHours(punchInLocalTs, punchOutLocalTs);
                    duration = parseFloat(hours);
                  }
                    punch.tripDuration = duration;
                    punch.deviceDetails = DEVICE_DETAILS;
                    punchesRef()
                    .doc(punch.punchId)
                    .get()
                    .then(async (docRef) => {
                      let punchData = docRef.data();
                      await setPunchHistory(docRef.id, punchData);
                      punch.version = docRef.data().version + 1;
                      let updatedPunch = {...punchData, ...punch};
                      await editPunches(docRef.id, updatedPunch);
                      resolve(true);
                    })
                    .catch((err) => {
                      console.error("in services > deleteTripPunch, err===" + err);
                      reject(err);
                    });
       })
    } catch (error) {
      console.error("in services > deleteTripPunch, Err===", error);
      reject(error);
    }
  });
}; 

// export const recordCenterApi = (smartSortRegion) => {
  
//   const requestOptions = {
//     method: 'POST',
//     headers: {  wmsCode : 'ONEIL' },
//     body: JSON.stringify({
//             api: "GET_RECORD_CENTER",
//             header: {
//             region: smartSortRegion
//             }
//          })
// };
// fetch('https://us-east4-irm-gleam-orchestration-poc.cloudfunctions.net/fs/api/recordCenter', requestOptions)
//     .then(async response => {
      
//         const isJson = response.headers.get('content-type')?.includes('application/json');
//         const data = isJson && await response.json();
//        alert("ss")
//         // check for error response
//         if (!response.ok) {
//             // get error message from body or default to response status
//             const error = (data && data.message) || response.status;
//             return Promise.reject(error);
//         }
//         if(data.result.lineItems)
//         {
//           let objArray = data.result.lineItems
//           let resultArray = objArray.map(({ id }) => id)
//           return resultArray
          
//         }
//         else{
//           return null
//         }
       
        
//     })
//     .catch(error => {
//        // this.setState({ errorMessage: error.toString() });
//       //  setRecordCenter([])
//         return null;
//        // console.error('There was an error!', error);
//     });


// };
